import { affectedService, bussinessService, complainantActaService, complainantGenderService, complainantGeneralService, complainantService, complainantTrafficService, containsService, denouncedActaService, denouncedGenderService, denouncedGeneralService, denouncedService, denouncedTrafficService, directionsService, fileServices, lawArticleService, lawService, legalGuardianService, paramsService, pedestrianService, procedencesService, subtypesDiligencesService, thirdLicenseService, thirdsService, usersService, vehiclesService, witnessService } from ".";
import "../Model/DenouncedActa";
import { Direction } from "../Model/Direction";
import "../Model/ThirdLicense";
import { REGISTERSCITATIONS, REGISTERSDETAINED, REGISTERSEXTERNALANTECEDENTS, REGISTERSINTOOUT, REGISTERSUNIDENTIFIEDPERSON, SERVICE_URL } from "../evironment";
import { dateInputFormatter, dateLocalInputFormatter, dateTimeInputFormatter } from "./Functions";
import { getAccessToken } from "./session";
function upDateSrc(file) {
    let url = new URL(`/api/files/content/${file.id}`, SERVICE_URL);
    if (SERVICE_URL.includes('localhost')) {
        url = new URL(`/files/content/${file.id}`, SERVICE_URL);
    }
    url.searchParams.set('access_token', getAccessToken());
    return url.toString();
}
export class WriteFileService {
    async writeGenderFile(diligence, initialManifestation, finalManifestation, manifestationGender, file, complainantId, denouncedId, witnessId) {
        let data, subtype, denouncedGender, complainantGender, policeInitial, thirdComplainant, complainant, collegiateComplainant, denounced, thirdDenounced, collegiateDenounced, witness, thirdWitness, policeFinal, thirdComplainantAddress, thirdDenouncedAddress, thirdWitnessAddress, collegiateComplainantAddress, collegiateDenouncedAddress;
        if (diligence.subDiligenceTypeId != null) {
            subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);
        }
        if (initialManifestation.userId != null) {
            policeInitial = await usersService.findOne(initialManifestation.userId);
        }
        if (finalManifestation.userId != null) {
            policeFinal = await usersService.findOne(finalManifestation.userId);
        }
        try {
            if (denouncedId)
                denouncedGender = await denouncedGenderService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainantGender = await complainantGenderService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainant = await complainantService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (denouncedId)
                denounced = await denouncedService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witnessId)
                witness = await witnessService.findOne(witnessId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        // third complainant information
        try {
            if (complainantGender) {
                thirdComplainant = await thirdsService.findOne(complainantGender.complainantThirId);
            }
        }
        catch (error) {
            console.log(error);
        }
        if (complainant) {
            if (complainant.collegiate != null) {
                collegiateComplainant = await thirdsService.findOne(complainant.collegiate);
                collegiateComplainantAddress = new Direction(await directionsService.findOne(collegiateComplainant.addressId));
            }
        }
        try {
            if (thirdComplainant) {
                thirdComplainantAddress = new Direction(await directionsService.findOne(thirdComplainant.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        // third denounced information
        try {
            if (denouncedGender) {
                thirdDenounced = await thirdsService.findOne(denouncedGender.denouncedThirId);
            }
        }
        catch (error) {
            console.log(error);
        }
        if (denounced) {
            if (denounced.collegiate != null) {
                collegiateDenounced = await thirdsService.findOne(denounced.collegiate);
                collegiateDenouncedAddress = new Direction(await directionsService.findOne(collegiateDenounced.addressId));
            }
        }
        try {
            if (thirdDenounced) {
                thirdDenouncedAddress = new Direction(await directionsService.findOne(thirdDenounced.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        // third witness information
        try {
            if (witness) {
                thirdWitness = await thirdsService.findOne(witness.witnessThird);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witness) {
                thirdWitnessAddress = new Direction(await directionsService.findOne(thirdWitness.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            data = {
                n_diligencia: diligence.diligenceNumber,
                fecha_diligencia: dateLocalInputFormatter(diligence.entryDate),
                hora_diligencia: dateTimeInputFormatter(diligence.entryDate),
                n_instructor: diligence.instructorId != null ? await this.getName(diligence.instructorId) : '',
                n_secretario: diligence.secretaryId != null ? await this.getName(diligence.secretaryId) : '',
                n_expediente: diligence.proceedingsNumber,
                tipo_diligencia: diligence.diligenceTypeId != null ? await this.getName(diligence.diligenceTypeId) : "",
                subtipo_diligencia: subtype.subTypeDiligence,
                remision: diligence.courtId != null ? await this.getName(diligence.courtId) : "",
                //manifestacion inicial
                m_policia_inicial: policeInitial ? policeInitial.name : "",
                fecha_manifestacion_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateCreated) : '',
                hora_manifestacion_inicial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateCreated) : '',
                fecha_cita_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateAppointment) : '',
                hora_cita_incial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateAppointment) : '',
                manifestacion_inicial: initialManifestation ? initialManifestation.manifestation : null,
                presenta_inicial: initialManifestation ? initialManifestation.present : null,
                entrega_inicial: initialManifestation ? initialManifestation.delivery : null,
                // victimas
                nombre_victima: thirdComplainant ? thirdComplainant.name : '',
                apellido1_victima: thirdComplainant ? thirdComplainant.surname1 : null,
                apellido2_victima: thirdComplainant ? thirdComplainant.surname2 : null,
                identificacion_victima: thirdComplainant ? thirdComplainant.document : null,
                telefono1_victima: thirdComplainant ? thirdComplainant.phone1 : null,
                telefono2_victima: thirdComplainant ? thirdComplainant.phone2 : null,
                fec_nac_victima: thirdComplainant ? dateLocalInputFormatter(thirdComplainant.birthday) : null,
                correo_victima: thirdComplainant ? thirdComplainant.email : null,
                tipo_via_victima: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetTypeId != null ? await this.getName(thirdComplainantAddress.streetTypeId) : null,
                nombre_via_victima: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetId != null ? await this.getName(thirdComplainantAddress.streetId) : null,
                numero_victima: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.number != null ? thirdComplainantAddress.number : null,
                municipio_victima: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.municipalityId != null ? await this.getName(thirdComplainantAddress.municipalityId) : null,
                zona_victima: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.districId != null ? await this.getName(thirdComplainantAddress.districId) : null,
                //colegiado
                nombre_colegiado_victima: collegiateComplainant ? collegiateComplainant.name : null,
                apellido1_colegiado_victima: collegiateComplainant ? collegiateComplainant.surname1 : null,
                apellido2_colegiado_victima: collegiateComplainant ? collegiateComplainant.surname2 : null,
                identificación_colegiado_victima: collegiateComplainant ? collegiateComplainant.document : null,
                telefono1_colegiado_victima: collegiateComplainant ? collegiateComplainant.phone1 : null,
                telefono2_colegiado_victima: collegiateComplainant ? collegiateComplainant.phone2 : null,
                correo_colegiado_victima: collegiateComplainant ? collegiateComplainant.email : null,
                num_colegiado_victima: collegiateComplainant ? collegiateComplainant.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_victima: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetTypeId != null ? await this.getName(collegiateComplainantAddress.streetTypeId) : null,
                nombre_via_colegiado_victima: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetId != null ? await this.getName(collegiateComplainantAddress.streetId) : null,
                numero_colegiado_victima: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.number != null ? collegiateComplainantAddress.number : null,
                municipio_colegiado_victima: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.municipalityId != null ? await this.getName(collegiateComplainantAddress.municipalityId) : null,
                zona_colegiado_victima: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.districId != null ? await this.getName(collegiateComplainantAddress.districId) : null,
                fecha_manifestacion_victima: complainant ? dateLocalInputFormatter(complainant.dateCreated) : null,
                hora_manifestacion_victima: complainant ? dateTimeInputFormatter(complainant.dateCreated) : null,
                manifestacion_victima: complainant ? complainant.manifestation : null,
                presenta_victima: complainant ? complainant.present : null,
                entrega_victima: complainant ? complainant.delivery : null,
                domicilio_secreto: complainantGender ? complainantGender.secretAddress == false ? 'no' : 'si' : null,
                telefono_secreto: complainantGender ? complainantGender.secretPhone == false ? 'no' : 'si' : null,
                abogado: complainantGender ? complainantGender.lawyerToAssist == false ? 'no' : 'si' : null,
                telefono_abogado: complainantGender ? complainantGender.lawyerPhone == false ? 'no' : 'si' : null,
                ha_denunciado: complainantGender ? complainantGender.reportPreviousAttacker == false ? 'no' : 'si' : null,
                comunicacion_agresor: complainantGender ? complainantGender.prohibitCommunicatingAgresor == false ? 'no' : 'si' : null,
                procedimiento_judicial: complainantGender ? complainantGender.previousJudgments == false ? 'no' : 'si' : null,
                posee_armas: complainantGender ? complainantGender.hasWeaponAttacker == false ? 'no' : 'si' : null,
                convive_domicilio_agresor: complainantGender ? complainantGender.coexistsWithAggressor == false ? 'no' : 'si' : null,
                agresor_abandone: complainantGender ? complainantGender.abandonAggressorAddress == false ? 'no' : 'si' : null,
                prohibir_acercar_agresor: complainantGender ? complainantGender.prohibitApproachingAggressor == false ? 'no' : 'si' : null,
                abandona_domicilio: complainantGender ? complainantGender.abandonHome == false ? 'no' : 'si' : null,
                acoger: complainantGender ? complainantGender.hostPossibility == false ? 'no' : 'si' : null,
                contactar_colegio_abogados: complainantGender ? complainantGender.contactLawSchool == false ? 'no' : 'si' : null,
                //agresores
                nombre_agresor: thirdDenounced ? thirdDenounced.name : null,
                apellido1_agresor: thirdDenounced ? thirdDenounced.surname1 : null,
                apellido2_agresor: thirdDenounced ? thirdDenounced.surname2 : null,
                identificacion_agresor: thirdDenounced ? thirdDenounced.document : null,
                telefono1_agresor: thirdDenounced ? thirdDenounced.phone1 : null,
                telefono2_agresor: thirdDenounced ? thirdDenounced.phone2 : null,
                fec_nac_agresor: thirdDenounced ? dateLocalInputFormatter(thirdDenounced.birthday) : null,
                correo_agresor: thirdDenounced ? thirdDenounced.email : null,
                tipo_via_agresor: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetTypeId != null ? await this.getName(thirdDenouncedAddress.streetTypeId) : null,
                nombre_via_agresor: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetId != null ? await this.getName(thirdDenouncedAddress.streetId) : null,
                numero_agresor: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.number != null ? thirdDenouncedAddress.number : null,
                municipio_agresor: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.municipalityId != null ? await this.getName(thirdDenouncedAddress.municipalityId) : null,
                zona_agresor: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.districId != null ? await this.getName(thirdDenouncedAddress.districId) : null,
                //colegiado
                nombre_colegiado_agresor: collegiateDenounced ? collegiateDenounced.name : null,
                apellido1_colegiado_agresor: collegiateDenounced ? collegiateDenounced.surname1 : null,
                apellido2_colegiado_agresor: collegiateDenounced ? collegiateDenounced.surname2 : null,
                identificación_colegiado_agresor: collegiateDenounced ? collegiateDenounced.document : null,
                telefono1_colegiado_agresor: collegiateDenounced ? collegiateDenounced.phone1 : null,
                telefono2_colegiado_agresor: collegiateDenounced ? collegiateDenounced.phone2 : null,
                correo_colegiado_agresor: collegiateDenounced ? collegiateDenounced.email : null,
                num_colegiado_agresor: collegiateDenounced ? collegiateDenounced.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_agresor: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetTypeId != null ? await this.getName(collegiateDenouncedAddress.streetTypeId) : null,
                nombre_via_colegiado_agresor: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetId != null ? await this.getName(collegiateDenouncedAddress.streetId) : null,
                numero_colegiado_agresor: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.number != null ? collegiateDenouncedAddress.number : null,
                municipio_colegiado_agresor: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.municipalityId != null ? await this.getName(collegiateDenouncedAddress.municipalityId) : null,
                zona_colegiado_agresor: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.districId != null ? await this.getName(collegiateDenouncedAddress.districId) : null,
                fecha_manifestacion_agresor: denounced ? dateLocalInputFormatter(denounced.dateCreated) : null,
                hora_manifestacion_agresor: denounced ? dateTimeInputFormatter(denounced.dateCreated) : null,
                manifestacion_agresor: denounced ? denounced.manifestation : null,
                presenta_agresor: denounced ? denounced.present : null,
                entrega_agresor: denounced ? denounced.delivery : null,
                situacion_economica: denouncedGender ? denouncedGender.economicSituation : null,
                profesion: denouncedGender && denouncedGender.professionId ? await this.getName(denouncedGender.professionId) : "",
                situacion_laboral: denouncedGender && denouncedGender.employmentSituation ? await this.getName(denouncedGender.employmentSituation) : "",
                centro_de_trabajo: denouncedGender && denouncedGender.workplaceId ? await this.getName(denouncedGender.workplaceId) : "",
                salud: denouncedGender && denouncedGender.healthStatus ? await this.getName(denouncedGender.healthStatus) : "",
                temperamento: denouncedGender ? denouncedGender.temperament : null,
                antecedentes_v_genero: denouncedGender ? denouncedGender.criminalRecord == false ? 'no' : 'si' : null,
                cumplimiento_cargas_familiares: denouncedGender ? denouncedGender.familyResponsabilities == false ? 'no' : 'si' : null,
                lugares_frecuenta: denouncedGender ? denouncedGender.frequentPlaces : null,
                adicciones: denouncedGender ? denouncedGender.addictions : null,
                // testigos
                nombre_testigo: thirdWitness ? thirdWitness.name : '',
                apellido1_testigo: thirdWitness ? thirdWitness.surname1 : null,
                apellido2_testigo: thirdWitness ? thirdWitness.surname2 : null,
                identificacion_testigo: thirdWitness ? thirdWitness.document : null,
                telefono1_testigo: thirdWitness ? thirdWitness.phone1 : null,
                telefono2_testigo: thirdWitness ? thirdWitness.phone2 : null,
                fec_nac_testigo: thirdWitness ? dateLocalInputFormatter(thirdWitness.birthday) : null,
                correo_testigo: thirdWitness ? thirdWitness.email : null,
                tipo_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetTypeId != null ? await this.getName(thirdWitnessAddress.streetTypeId) : null,
                nombre_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetId != null ? await this.getName(thirdWitnessAddress.streetId) : null,
                numero_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.number != null ? thirdWitnessAddress.number : null,
                municipio_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.municipalityId != null ? await this.getName(thirdWitnessAddress.municipalityId) : null,
                zona_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.districId != null ? await this.getName(thirdWitnessAddress.districId) : null,
                fecha_manifestacion_testigo: witness ? dateLocalInputFormatter(witness.date) : '',
                hora_manifestacion_testigo: witness ? dateTimeInputFormatter(witness.date) : '',
                manifestacion_testigo: witness ? witness.manifestacion : '',
                presenta_testigo: witness ? witness.presents : '',
                // manifestacion final
                m_policia_final: policeFinal ? policeFinal.name : '',
                fecha_manifestacion_final: finalManifestation.dateCreated != null ? dateLocalInputFormatter(finalManifestation.dateCreated) : '',
                hora_manifestacion_final: finalManifestation.dateCreated != null ? dateTimeInputFormatter(finalManifestation.dateCreated) : '',
                fecha_cita_final: finalManifestation.dateAppointment != null ? dateLocalInputFormatter(finalManifestation.dateAppointment) : '',
                hora_cita_final: finalManifestation.dateAppointment != null ? dateTimeInputFormatter(finalManifestation.dateAppointment) : '',
                manifestacion_final: finalManifestation.manifestation,
                presenta_final: finalManifestation.present,
                entrega_final: finalManifestation.delivery,
                muestras: manifestationGender.samplesInvolved == false ? 'no' : 'si',
                tipos_muestras: manifestationGender.sampleTypes,
                armas: manifestationGender.weaponsIntervene == false ? 'no' : 'si',
                tramite_retirada_armas: manifestationGender.armsWithdrawalProcedure == false ? 'no' : 'si',
                tipos_armas: manifestationGender.typesWeapons,
                datos_interes: manifestationGender.interestingData,
                observaciones: manifestationGender.observations,
                traslado_medico: manifestationGender.transferHealthCenter == false ? 'no' : 'si',
                acompanar_domicilio: manifestationGender.accompanyAddressEffects == false ? 'no' : 'si',
                traslado_casa_familiar: manifestationGender.accompanyFamilyHome == false ? 'no' : 'si',
                centro_acogida: manifestationGender.transferReceptionCenter == false ? 'no' : 'si',
                n_folio_remision: manifestationGender.numFoliosRemission,
                fecha_remision: manifestationGender.referralDate != null ? dateLocalInputFormatter(manifestationGender.referralDate) : '',
                acta_independizada: manifestationGender.independentMinutes,
                citaciones: manifestationGender.citations,
                cuerpo_traspaso: manifestationGender.bodyTransfer
            };
        }
        catch (error) {
            console.log(error);
        }
        try {
            await fileServices.downloadFile(diligence.diligenceTypeId, diligence.diligenceNumber, data, file);
        }
        catch (error) {
            console.log(error);
        }
    }
    async writeTrafficFile(diligence, initialManifestation, finalManifestation, manifestationTraffic, file, complainantId, denouncedId, witnessId, pedestrianId, affectedId, picsArray) {
        let data, subtype, denouncedTraffic, complainantTraffic, policeInitial, thirdDriver, complainant, collegiateDriver, denounced, thirdDenounced, collegiateDenounced, witness, thirdWitness, policeFinal, driverCar, pedestrian, thirdPedestrian, affected, thirdAffected, thirdDriverAddress, thirdPedestrianAddress, thirdDenouncedAddress, thirdWitnessAddress, thirdAffectedAddress, collegiateDriverAddress, collegiateDenouncedAddress, insuranceTaker, insuranceTakerAddress, carOwner, carOwnerAddress, thirdLicenses;
        if (diligence.subDiligenceTypeId != null) {
            subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);
        }
        if (initialManifestation.userId != null) {
            policeInitial = await usersService.findOne(initialManifestation.userId);
        }
        if (finalManifestation.userId != null) {
            policeFinal = await usersService.findOne(finalManifestation.userId);
        }
        try {
            if (denouncedId)
                denouncedTraffic = await denouncedTrafficService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainantTraffic = await complainantTrafficService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainant = await complainantService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (denouncedId)
                denounced = await denouncedService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witness)
                witness = await witnessService.findOne(witnessId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (pedestrianId)
                pedestrian = await pedestrianService.findOne(pedestrianId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (affectedId)
                affected = await affectedService.findOne(affectedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        // third driver information
        if (complainantTraffic) {
            thirdDriver = await thirdsService.findOne(complainantTraffic.complainantThirId);
            if (complainantTraffic.vehicle_id) {
                driverCar = await vehiclesService.findOne(complainantTraffic.vehicle_id);
                if (driverCar.insuranceTakerId) {
                    insuranceTaker = await thirdsService.findOne(driverCar.insuranceTakerId);
                    insuranceTakerAddress = new Direction(await directionsService.findOne(insuranceTaker.addressId));
                }
                if (driverCar.thirdId) {
                    carOwner = await thirdsService.findOne(driverCar.thirdId);
                    carOwnerAddress = new Direction(await directionsService.findOne(carOwner.addressId));
                }
            }
            if (thirdDriver.has_license) {
                thirdLicenses = await thirdLicenseService.getThirdLicensByThirdId(thirdDriver.id);
            }
        }
        if (complainant) {
            if (complainant.collegiate != null) {
                collegiateDriver = await thirdsService.findOne(complainant.collegiate);
                collegiateDriverAddress = new Direction(await directionsService.findOne(collegiateDriver.addressId));
            }
        }
        try {
            if (thirdDriver) {
                thirdDriverAddress = new Direction(await directionsService.findOne(thirdDriver.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        //third denounced information
        try {
            if (denouncedTraffic) {
                thirdDenounced = await thirdsService.findOne(denouncedTraffic.denouncedThirId);
            }
        }
        catch (error) {
            console.log(error);
        }
        if (denounced) {
            if (denounced.collegiate != null) {
                collegiateDenounced = await thirdsService.findOne(denounced.collegiate);
                collegiateDenouncedAddress = new Direction(await directionsService.findOne(collegiateDenounced.addressId));
            }
        }
        try {
            if (thirdDenounced) {
                thirdDenouncedAddress = new Direction(await directionsService.findOne(thirdDenounced.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        //third witness information
        try {
            if (witness) {
                thirdWitness = await thirdsService.findOne(witness.witnessThird);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witness) {
                thirdWitnessAddress = new Direction(await directionsService.findOne(thirdWitness.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        // third pedestrian information
        try {
            if (pedestrian) {
                thirdPedestrian = await thirdsService.findOne(pedestrian.pedestrianThirId);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (pedestrian) {
                thirdPedestrianAddress = new Direction(await directionsService.findOne(thirdPedestrian.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        //third affected information
        try {
            if (affected) {
                thirdAffected = await thirdsService.findOne(affected.affectedThird);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (affected) {
                thirdAffectedAddress = new Direction(await directionsService.findOne(thirdAffected.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            data = {
                n_diligencia: diligence.diligenceNumber,
                fecha_diligencia: dateLocalInputFormatter(diligence.entryDate),
                hora_diligencia: dateTimeInputFormatter(diligence.entryDate),
                n_instructor: diligence.instructorId != null ? await this.getName(diligence.instructorId) : '',
                n_secretario: diligence.secretaryId != null ? await this.getName(diligence.secretaryId) : '',
                n_expediente: diligence.proceedingsNumber,
                tipo_diligencia: diligence.diligenceTypeId != null ? await this.getName(diligence.diligenceTypeId) : "",
                subtipo_diligencia: subtype.subTypeDiligence,
                remision: diligence.courtId != null ? await this.getName(diligence.courtId) : "",
                //manifestacion inicial
                m_policia_inicial: policeInitial ? policeInitial.name : "",
                fecha_manifestacion_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateCreated) : null,
                hora_manifestacion_inicial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateCreated) : '',
                fecha_cita_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateAppointment) : null,
                hora_cita_incial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateAppointment) : '',
                manifestacion_inicial: initialManifestation ? initialManifestation.manifestation : null,
                presenta_inicial: initialManifestation ? initialManifestation.present : null,
                entrega_inicial: initialManifestation ? initialManifestation.delivery : null,
                // conductores
                nombre_conductor: thirdDriver ? thirdDriver.name : null,
                apellido1_conductor: thirdDriver ? thirdDriver.surname1 : null,
                apellido2_conductor: thirdDriver ? thirdDriver.surname2 : null,
                identificacion_conductor: thirdDriver ? thirdDriver.document : null,
                telefono1_conductor: thirdDriver ? thirdDriver.phone1 : null,
                telefono2_conductor: thirdDriver ? thirdDriver.phone2 : null,
                fec_nac_conductor: thirdDriver ? dateLocalInputFormatter(thirdDriver.birthday) : null,
                correo_conductor: thirdDriver ? thirdDriver.email : null,
                tipo_via_conductor: thirdDriverAddress instanceof Direction && thirdDriverAddress.streetTypeId != null ? await this.getName(thirdDriverAddress.streetTypeId) : null,
                nombre_via_conductor: thirdDriverAddress instanceof Direction && thirdDriverAddress.streetId != null ? await this.getName(thirdDriverAddress.streetId) : null,
                numero_conductor: thirdDriverAddress instanceof Direction && thirdDriverAddress.number != null ? thirdDriverAddress.number : null,
                municipio_conductor: thirdDriverAddress instanceof Direction && thirdDriverAddress.municipalityId != null ? await this.getName(thirdDriverAddress.municipalityId) : null,
                zona_conductor: thirdDriverAddress instanceof Direction && thirdDriverAddress.districId != null ? await this.getName(thirdDriverAddress.districId) : null,
                //colegiado
                nombre_colegiado_conductor: collegiateDriver ? collegiateDriver.name : null,
                apellido1_colegiado_conductor: collegiateDriver ? collegiateDriver.surname1 : null,
                apellido2_colegiado_conductor: collegiateDriver ? collegiateDriver.surname2 : null,
                identificacion_colegiado_conductor: collegiateDriver ? collegiateDriver.document : null,
                telefono1_colegiado_conductor: collegiateDriver ? collegiateDriver.phone1 : null,
                telefono2_colegiado_conductor: collegiateDriver ? collegiateDriver.phone2 : null,
                correo_colegiado_conductor: collegiateDriver ? collegiateDriver.email : null,
                num_colegiado_conductor: collegiateDriver ? collegiateDriver.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_conductor: collegiateDriverAddress instanceof Direction && collegiateDriverAddress.streetTypeId != null ? await this.getName(collegiateDriverAddress.streetTypeId) : null,
                nombre_via_colegiado_conductor: collegiateDriverAddress instanceof Direction && collegiateDriverAddress.streetId != null ? await this.getName(collegiateDriverAddress.streetId) : null,
                numero_colegiado_conductor: collegiateDriverAddress instanceof Direction && collegiateDriverAddress.number != null ? collegiateDriverAddress.number : null,
                municipio_colegiado_conductor: collegiateDriverAddress instanceof Direction && collegiateDriverAddress.municipalityId != null ? await this.getName(collegiateDriverAddress.municipalityId) : null,
                zona_colegiado_conductor: collegiateDriverAddress instanceof Direction && collegiateDriverAddress.districId != null ? await this.getName(collegiateDriverAddress.districId) : null,
                fecha_manifestacion_conductor: complainant ? dateLocalInputFormatter(complainant.dateCreated) : null,
                hora_manifestacion_conductor: complainant ? dateTimeInputFormatter(complainant.dateCreated) : null,
                manifestacion_conductor: complainant ? complainant.manifestation : null,
                presenta_conductor: complainant ? complainant.present : null,
                entrega_conductor: complainant ? complainant.delivery : null,
                //vehicle information
                matricula: driverCar ? driverCar.plate : '',
                tipo_vehiculo: driverCar ? await this.getName(driverCar.vehicleType) : null,
                marca_vehiculo: driverCar ? await this.getName(driverCar.markId) : null,
                modelo_vehiculo: driverCar ? await this.getName(driverCar.modelId) : null,
                aseguradora: driverCar ? await this.getName(driverCar.insuranceCarrierId) : null,
                n_poliza: driverCar ? driverCar.policyNumber : null,
                n_bastidor: driverCar ? driverCar.frame : null,
                fecha_matriculacion: driverCar ? dateLocalInputFormatter(driverCar.plateDate) : null,
                fecha_val_poliza: driverCar ? dateLocalInputFormatter(driverCar.validityPolicy) : null,
                fecha_val_inspeccion: driverCar ? dateLocalInputFormatter(driverCar.validityInpeccion) : null,
                daños_vehiculo: complainantTraffic ? complainantTraffic.vehicle_damage : null,
                remolque: complainantTraffic ? complainantTraffic.trailer_registration : null,
                permiso_conducir: thirdLicenses && thirdLicenses.length > 0 ? thirdLicenses.map(license => license.license_name) : null,
                periodo_validez: thirdLicenses && thirdLicenses.length > 0 ? thirdLicenses.map(license => dateLocalInputFormatter(license.exp_date)) : null,
                //tomador del seguro
                nombre_tomador_conductor: insuranceTaker ? insuranceTaker.name : null,
                apellido1_tomador_conductor: insuranceTaker ? insuranceTaker.surname1 : null,
                apellido2_tomador_conductor: insuranceTaker ? insuranceTaker.surname2 : null,
                identificacion_tomador_conductor: insuranceTaker ? insuranceTaker.document : null,
                telefono1_tomador_conductor: insuranceTaker ? insuranceTaker.phone1 : null,
                telefono2_tomador_conductor: insuranceTaker ? insuranceTaker.phone2 : null,
                correo_tomador_conductor: insuranceTaker ? insuranceTaker.email : null,
                //direccion tomador
                tipo_via_tomador_conductor: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.streetTypeId != null ? await this.getName(insuranceTakerAddress.streetTypeId) : null,
                nombre_via_tomador_conductor: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.streetId != null ? await this.getName(insuranceTakerAddress.streetId) : null,
                numero_tomador_conductor: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.number != null ? insuranceTakerAddress.number : null,
                municipio_tomador_conductor: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.municipalityId != null ? await this.getName(insuranceTakerAddress.municipalityId) : null,
                zona_tomador_conductor: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.districId != null ? await this.getName(insuranceTakerAddress.districId) : null,
                //propietario del vehículo
                nombre_propietario_conductor: carOwner ? carOwner.name : null,
                apellido1_propietario_conductor: carOwner ? carOwner.surname1 : null,
                apellido2_propietario_conductor: carOwner ? carOwner.surname2 : null,
                identificacion_propietario_conductor: carOwner ? carOwner.document : null,
                telefono1_propietario_conductor: carOwner ? carOwner.phone1 : null,
                telefono2_propietario_conductor: carOwner ? carOwner.phone2 : null,
                correo_propietario_conductor: carOwner ? carOwner.email : null,
                //direccion propietario
                tipo_via_propietario_conductor: carOwnerAddress instanceof Direction && carOwnerAddress.streetTypeId != null ? await this.getName(carOwnerAddress.streetTypeId) : null,
                nombre_via_propietario_conductor: carOwnerAddress instanceof Direction && carOwnerAddress.streetId != null ? await this.getName(carOwnerAddress.streetId) : null,
                numero_propietario_conductor: carOwnerAddress instanceof Direction && carOwnerAddress.number != null ? carOwnerAddress.number : null,
                municipio_propietario_conductor: carOwnerAddress instanceof Direction && carOwnerAddress.municipalityId != null ? await this.getName(carOwnerAddress.municipalityId) : null,
                zona_propietario_conductor: carOwnerAddress instanceof Direction && carOwnerAddress.districId != null ? await this.getName(carOwnerAddress.districId) : null,
                //alcohol
                prueba_alcoholemia: complainantTraffic.perform_alcoholemia == false ? 'no' : 'si',
                hora_toma_1: complainantTraffic.time_p_alcohol1 != null ? dateTimeInputFormatter(complainantTraffic.time_p_alcohol1) : '',
                resultado_toma_1: complainantTraffic.result_p_alcohol1 != null ? complainantTraffic.result_p_alcohol1 : '',
                hora_toma_2: complainantTraffic.time_p_alcohol2 != null ? dateTimeInputFormatter(complainantTraffic.time_p_alcohol2) : '',
                resultado_toma_2: complainantTraffic.result_p_alcohol2 != null ? complainantTraffic.result_p_alcohol2 : '',
                execede: complainantTraffic.exceeds_060 == false ? 'no' : 'si',
                extraccion_sangre: complainantTraffic.urine_blood_extraction == false ? 'no' : 'si',
                bajo_influencia: complainantTraffic.low_influence == false ? 'no' : 'si',
                examen_medico: complainantTraffic.medical_examination == false ? 'no' : 'si',
                historial_medico: complainantTraffic ? complainantTraffic.medical_history : null,
                parte_facultativo: complainantTraffic ? complainantTraffic.optional_part : null,
                defectos_fisicos: complainantTraffic.physical_defects == false ? 'no' : 'si',
                rostro: complainantTraffic ? complainantTraffic.face_id : null,
                vestimenta: complainantTraffic ? complainantTraffic.dress_id : null,
                facciones: complainantTraffic ? complainantTraffic.face_id : null,
                movimientos: complainantTraffic ? complainantTraffic.movements_id : null,
                constitucion_fisica: complainantTraffic ? complainantTraffic.physical_constitution_id : null,
                voz: complainantTraffic ? complainantTraffic.voice_id : null,
                pupilas: complainantTraffic ? complainantTraffic.pupils_id : null,
                comportamiento: complainantTraffic ? complainantTraffic.behavior_id : null,
                aspecto: complainantTraffic ? complainantTraffic.external_aspect_id : null,
                mirada: complainantTraffic ? complainantTraffic.look_id : null,
                otros_detalles: complainantTraffic ? complainantTraffic.others_detalles_id : null,
                respiracion: complainantTraffic ? complainantTraffic.respiration_id : null,
                informe_administrativo: complainantTraffic.administrative_infection == false ? 'no' : 'si',
                abogado: complainantTraffic.appoints_lawyer == false ? 'no' : 'si',
                oficio: complainantTraffic.ex_officio == false ? 'no' : 'si',
                aviso_familiar: complainantTraffic.family_notice == false ? 'no' : 'si',
                interprete: complainantTraffic.interpreter == false ? 'no' : 'si',
                quiere_declarar: complainantTraffic.want_declare == false ? 'no' : 'si',
                quiere_denunciar: complainantTraffic.complainant == false ? 'no' : 'si',
                boletin: complainantTraffic ? complainantTraffic.num_boletin : null,
                // ocupantes
                nombre_ocupante: thirdDenounced ? thirdDenounced.name : null,
                apellido1_ocupante: thirdDenounced ? thirdDenounced.surname1 : null,
                apellido2_ocupante: thirdDenounced ? thirdDenounced.surname2 : null,
                identificacion_ocupante: thirdDenounced ? thirdDenounced.document : null,
                telefono1_ocupante: thirdDenounced ? thirdDenounced.phone1 : null,
                telefono2_ocupante: thirdDenounced ? thirdDenounced.phone2 : null,
                fec_nac_ocupante: thirdDenounced ? dateLocalInputFormatter(thirdDenounced.birthday) : null,
                correo_ocupante: thirdDenounced ? thirdDenounced.email : null,
                tipo_via_ocupante: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetTypeId != null ? await this.getName(thirdDenouncedAddress.streetTypeId) : null,
                nombre_via_ocupante: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetId != null ? await this.getName(thirdDenouncedAddress.streetId) : null,
                numero_ocupante: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.number != null ? thirdDenouncedAddress.number : null,
                municipio_ocupante: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.municipalityId != null ? await this.getName(thirdDenouncedAddress.municipalityId) : null,
                zona_ocupante: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.districId != null ? await this.getName(thirdDenouncedAddress.districId) : null,
                //colegiado
                nombre_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.name : null,
                apellido1_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.surname1 : null,
                apellido2_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.surname2 : null,
                identificación_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.document : null,
                telefono1_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.phone1 : null,
                telefono2_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.phone2 : null,
                correo_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.email : null,
                num_colegiado_ocupante: collegiateDenounced ? collegiateDenounced.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_ocupante: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetTypeId != null ? await this.getName(collegiateDenouncedAddress.streetTypeId) : null,
                nombre_via_colegiado_ocupante: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetId != null ? await this.getName(collegiateDenouncedAddress.streetId) : null,
                numero_colegiado_ocupante: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.number != null ? collegiateDenouncedAddress.number : null,
                municipio_colegiado_ocupante: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.municipalityId != null ? await this.getName(collegiateDenouncedAddress.municipalityId) : null,
                zona_colegiado_ocupante: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.districId != null ? await this.getName(collegiateDenouncedAddress.districId) : null,
                fecha_manifestacion_ocupante: denounced && denounced.dateCreated != null ? dateLocalInputFormatter(denounced.dateCreated) : null,
                hora_manifestacion_ocupante: denounced && denounced.dateCreated != null ? dateTimeInputFormatter(denounced.dateCreated) : null,
                manifestacion_ocupante: denounced ? denounced.manifestation : null,
                presenta_ocupante: denounced ? denounced.delivery : null,
                historial_medico_ocupante: denouncedTraffic ? denouncedTraffic.medicalHistory : null,
                parte_facultativo_ocupante: denouncedTraffic ? denouncedTraffic.optionalPart : null,
                // testigos
                nombre_testigo: thirdWitness ? thirdWitness.name : null,
                apellido1_testigo: thirdWitness ? thirdWitness.surname1 : null,
                apellido2_testigo: thirdWitness ? thirdWitness.surname2 : null,
                identificacion_testigo: thirdWitness ? thirdWitness.document : null,
                telefono1_testigo: thirdWitness ? thirdWitness.phone1 : null,
                telefono2_testigo: thirdWitness ? thirdWitness.phone2 : null,
                fec_nac_testigo: thirdWitness ? dateLocalInputFormatter(thirdWitness.birthday) : null,
                correo_testigo: thirdWitness ? thirdWitness.email : null,
                tipo_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetTypeId != null ? await this.getName(thirdWitnessAddress.streetTypeId) : null,
                nombre_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetId != null ? await this.getName(thirdWitnessAddress.streetId) : null,
                numero_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.number != null ? thirdWitnessAddress.number : null,
                municipio_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.municipalityId != null ? await this.getName(thirdWitnessAddress.municipalityId) : null,
                zona_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.districId != null ? await this.getName(thirdWitnessAddress.districId) : null,
                fecha_manifestacion_testigo: witness ? dateLocalInputFormatter(witness.date) : '',
                hora_manifestacion_testigo: witness ? dateTimeInputFormatter(witness.date) : '',
                manifestacion_testigo: witness ? witness.manifestacion : '',
                presenta_testigo: witness ? witness.presents : '',
                // peatones
                nombre_peaton: thirdPedestrian ? thirdPedestrian.name : null,
                apellido1_peaton: thirdPedestrian ? thirdPedestrian.surname1 : null,
                apellido2_peaton: thirdPedestrian ? thirdPedestrian.surname2 : null,
                identificacion_peaton: thirdPedestrian ? thirdPedestrian.document : null,
                telefono1_peaton: thirdPedestrian ? thirdPedestrian.phone1 : null,
                telefono2_peaton: thirdPedestrian ? thirdPedestrian.phone2 : null,
                fec_nac_peaton: thirdPedestrian ? dateLocalInputFormatter(thirdPedestrian.birthday) : null,
                correo_peaton: thirdPedestrian ? thirdPedestrian.email : null,
                tipo_via_peaton: thirdPedestrianAddress instanceof Direction && thirdPedestrianAddress.streetTypeId != null ? await this.getName(thirdPedestrianAddress.streetTypeId) : null,
                nombre_via_peaton: thirdPedestrianAddress instanceof Direction && thirdPedestrianAddress.streetId != null ? await this.getName(thirdPedestrianAddress.streetId) : null,
                numero_peaton: thirdPedestrianAddress instanceof Direction && thirdPedestrianAddress.number != null ? thirdPedestrianAddress.number : null,
                municipio_peaton: thirdPedestrianAddress instanceof Direction && thirdPedestrianAddress.municipalityId != null ? await this.getName(thirdPedestrianAddress.municipalityId) : null,
                zona_peaton: thirdPedestrianAddress instanceof Direction && thirdPedestrianAddress.districId != null ? await this.getName(thirdPedestrianAddress.districId) : null,
                fecha_manifestacion_peaton: pedestrian ? dateLocalInputFormatter(pedestrian.dateCreated) : '',
                hora_manifestacion_peaton: pedestrian ? dateTimeInputFormatter(pedestrian.dateCreated) : '',
                manifestacion_peaton: pedestrian ? pedestrian.manifestation : null,
                presenta_peaton: pedestrian ? pedestrian.present : null,
                historial_medico_peaton: pedestrian ? pedestrian.medicalHistory : null,
                parte_facultativo_peaton: pedestrian ? pedestrian.medicalPart : null,
                // afectados
                nombre_afectado: thirdAffected ? thirdAffected.name : null,
                apellido1_afectado: thirdAffected ? thirdAffected.surname1 : null,
                apellido2_afectado: thirdAffected ? thirdAffected.surname2 : null,
                identificacion_afectado: thirdAffected ? thirdAffected.document : null,
                telefono1_afectado: thirdAffected ? thirdAffected.phone1 : null,
                telefono2_afectado: thirdAffected ? thirdAffected.phone2 : null,
                fec_nac_afectado: thirdAffected ? dateLocalInputFormatter(thirdAffected.birthday) : null,
                correo_afectado: thirdAffected ? thirdAffected.email : null,
                tipo_via_afectado: thirdAffectedAddress instanceof Direction && thirdAffectedAddress.streetTypeId != null ? await this.getName(thirdAffectedAddress.streetTypeId) : null,
                nombre_via_afectado: thirdAffectedAddress instanceof Direction && thirdAffectedAddress.streetId != null ? await this.getName(thirdAffectedAddress.streetId) : null,
                numero_afectado: thirdAffectedAddress instanceof Direction && thirdAffectedAddress.number != null ? thirdAffectedAddress.number : null,
                municipio_afectado: thirdAffectedAddress instanceof Direction && thirdAffectedAddress.municipalityId != null ? await this.getName(thirdAffectedAddress.municipalityId) : null,
                zona_afectado: thirdAffectedAddress instanceof Direction && thirdAffectedAddress.districId != null ? await this.getName(thirdAffectedAddress.districId) : null,
                fecha_manifestacion_afectado: affected ? dateLocalInputFormatter(affected.dateCreated) : null,
                hora_manifestacion_afectado: affected ? dateTimeInputFormatter(affected.dateCreated) : null,
                manifestacion_afectado: affected ? affected.manifestation : null,
                presenta_afectado: affected ? affected.present : null,
                // manifestacion final
                m_policia_final: policeFinal ? policeFinal.name : '',
                fecha_manifestacion_final: finalManifestation.dateCreated != null ? dateLocalInputFormatter(finalManifestation.dateCreated) : '',
                hora_manifestacion_final: finalManifestation.dateCreated != null ? dateTimeInputFormatter(finalManifestation.dateCreated) : '',
                fecha_cita_final: finalManifestation.dateAppointment != null ? dateLocalInputFormatter(finalManifestation.dateAppointment) : '',
                hora_cita_final: finalManifestation.dateAppointment != null ? dateTimeInputFormatter(finalManifestation.dateAppointment) : '',
                manifestacion_final: finalManifestation ? finalManifestation.manifestation : null,
                presenta_final: finalManifestation ? finalManifestation.present : null,
                entrega_final: finalManifestation ? finalManifestation.delivery : null,
                explicacion_ubicacion: manifestationTraffic ? manifestationTraffic.crowdedLocation : null,
                tipo_atestado: manifestationTraffic.crowdedType != null ? await this.getName(manifestationTraffic.crowdedType) : null,
                hora_comunica: manifestationTraffic ? dateTimeInputFormatter(manifestationTraffic.hourCommunicate) : null,
                hora_llegada: manifestationTraffic ? dateTimeInputFormatter(manifestationTraffic.arrivalTime) : null,
                informe: manifestationTraffic ? manifestationTraffic.report : null,
                comunicante: manifestationTraffic.communicantThird != null ? (await paramsService.findOne(manifestationTraffic.communicantThird)).name : null,
                senalizacion: manifestationTraffic ? manifestationTraffic.signaling : null,
                accidente_trafico: manifestationTraffic.trafficAccident == false ? 'no' : 'si',
                observaciones: manifestationTraffic ? manifestationTraffic.observations : null,
                caracteristicas_via: manifestationTraffic ? manifestationTraffic.featuresVia : null,
                huellas: manifestationTraffic ? manifestationTraffic.footprints : null,
                caracteristicas_dia: manifestationTraffic ? manifestationTraffic.characteristicsDay : null,
                control_preventivo: manifestationTraffic.preventiveControl == false ? 'no' : 'si',
                perdida_puntos: manifestationTraffic.lostPoints == false ? 'no' : 'si',
                decision_judicial: manifestationTraffic.judicialDecision == false ? 'no' : 'si',
                no_poseer_permiso: manifestationTraffic.notPossessPermission == false ? 'no' : 'si',
                vehiculo_inmovilizado: manifestationTraffic.vehicleImmobilization == false ? 'no' : 'si',
                persona_habilitada: manifestationTraffic.qualifiedPerson == false ? 'no' : 'si',
                anomalias_conduccion: manifestationTraffic ? manifestationTraffic.drivingAnomalies : null,
                etilometro_serie: manifestationTraffic.ethylmeterSeries != null ? await this.getName(manifestationTraffic.ethylmeterSeries) : null,
                fecha_verificacion_etilometro: dateLocalInputFormatter(manifestationTraffic.dateCheckEthilometer),
                n_actas_remision: manifestationTraffic ? manifestationTraffic.numMinutesRemision : null,
                n_folio_remision: manifestationTraffic ? manifestationTraffic.numFoliosRemision : null,
                fecha_remision: dateLocalInputFormatter(manifestationTraffic.referralDate),
                acta_independizada: manifestationTraffic ? manifestationTraffic.independentMinutes : null,
                n_citaciones: manifestationTraffic ? manifestationTraffic.numcitations : null,
                citaciones: manifestationTraffic ? manifestationTraffic.citations : null,
                cuerpo_traspaso: manifestationTraffic ? manifestationTraffic.bodyTransfer : null,
                croquis: manifestationTraffic ? manifestationTraffic.sketch : null,
                explicacion_croquis: manifestationTraffic ? manifestationTraffic.sketchExplanation : null,
                // Imágenes
                images: picsArray
            };
        }
        catch (error) {
            console.log(error);
        }
        try {
            await fileServices.downloadFile(diligence.diligenceTypeId, diligence.diligenceNumber, data, file);
        }
        catch (error) {
            console.log(error);
        }
    }
    async writeGeneralFile(diligence, initialManifestation, finalManifestation, manifestationGeneral, file, complainantId, denouncedId, witnessId, legalGuardianId) {
        let data, subtype, denouncedGeneral, complainantGeneral, policeInitial, thirdComplainant, complainant, collegiateComplainant, denounced, thirdDenounced, collegiateDenounced, witness, thirdWitness, policeFinal, thirdComplainantAddress, thirdDenouncedAddress, thirdWitnessAddress, complainantCar, collegiateComplainantAddress, collegiateDenouncedAddress, legalGuardian, thirdLegalGuardian, thirdLegalGuardianAddress, carOwner, carOwnerAddress, insuranceTaker, insuranceTakerAddress;
        if (diligence.subDiligenceTypeId != null) {
            subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);
        }
        if (initialManifestation.userId != null) {
            policeInitial = await usersService.findOne(initialManifestation.userId);
        }
        if (finalManifestation.userId != null) {
            policeFinal = await usersService.findOne(finalManifestation.userId);
        }
        try {
            if (denouncedId)
                denouncedGeneral = await denouncedGeneralService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainantGeneral = await complainantGeneralService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainant = await complainantService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (denouncedId)
                denounced = await denouncedService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witnessId)
                witness = await witnessService.findOne(witnessId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (legalGuardianId)
                legalGuardian = await legalGuardianService.findOne(legalGuardianId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        //third complainant information
        try {
            if (complainantGeneral)
                thirdComplainant = await thirdsService.findOne(complainantGeneral.complainantThirId);
        }
        catch (error) {
            console.log(error);
        }
        if (complainant && complainant.collegiate != null) {
            collegiateComplainant = await thirdsService.findOne(complainant.collegiate);
            collegiateComplainantAddress = new Direction(await directionsService.findOne(collegiateComplainant.addressId));
        }
        try {
            if (thirdComplainant)
                thirdComplainantAddress = new Direction(await directionsService.findOne(thirdComplainant.addressId));
        }
        catch (error) {
            console.log(error);
        }
        if (complainantGeneral && complainantGeneral.vehicleId != null) {
            complainantCar = await vehiclesService.findOne(complainantGeneral.vehicleId);
            if (complainantCar.thirdId) {
                carOwner = await thirdsService.findOne(complainantCar.thirdId);
                carOwnerAddress = new Direction(await directionsService.findOne(carOwner.addressId));
            }
            if (complainantCar.insuranceTakerId) {
                insuranceTaker = await thirdsService.findOne(complainantCar.insuranceTakerId);
                insuranceTakerAddress = new Direction(await directionsService.findOne(insuranceTaker.addressId));
            }
        }
        // third denounced information
        try {
            if (denouncedGeneral)
                thirdDenounced = await thirdsService.findOne(denouncedGeneral.denouncedThirId);
        }
        catch (error) {
            console.log(error);
        }
        if (denounced && denounced.collegiate != null) {
            collegiateDenounced = await thirdsService.findOne(denounced.collegiate);
            collegiateDenouncedAddress = new Direction(await directionsService.findOne(collegiateDenounced.addressId));
        }
        try {
            if (thirdDenounced)
                thirdDenouncedAddress = new Direction(await directionsService.findOne(thirdDenounced.addressId));
        }
        catch (error) {
            console.log(error);
        }
        //third witness information
        try {
            if (witness) {
                thirdWitness = await thirdsService.findOne(witness.witnessThird);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witness) {
                thirdWitnessAddress = new Direction(await directionsService.findOne(thirdWitness.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        //third legal guardian information
        try {
            if (legalGuardian) {
                thirdLegalGuardian = await thirdsService.findOne(legalGuardian.representante);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (legalGuardian) {
                thirdLegalGuardianAddress = new Direction(await directionsService.findOne(thirdLegalGuardian.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        console.log(legalGuardian, thirdLegalGuardian, thirdLegalGuardianAddress);
        try {
            data = {
                n_diligencia: diligence.diligenceNumber,
                fecha_diligencia: dateLocalInputFormatter(diligence.entryDate),
                hora_diligencia: dateTimeInputFormatter(diligence.entryDate),
                n_instructor: diligence.instructorId != null ? await this.getName(diligence.instructorId) : '',
                n_secretario: diligence.secretaryId != null ? await this.getName(diligence.secretaryId) : '',
                n_expediente: diligence.proceedingsNumber,
                tipo_diligencia: diligence.diligenceTypeId != null ? await this.getName(diligence.diligenceTypeId) : "",
                subtipo_diligencia: subtype.subTypeDiligence,
                remision: diligence.courtId != null ? await this.getName(diligence.courtId) : "",
                //manifestacion inicial
                m_policia_inicial: policeInitial ? policeInitial.name : "",
                fecha_manifestacion_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateCreated) : '',
                hora_manifestacion_inicial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateCreated) : '',
                fecha_cita_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateAppointment) : '',
                hora_cita_incial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateAppointment) : '',
                manifestacion_inicial: initialManifestation ? initialManifestation.manifestation : null,
                presenta_inicial: initialManifestation ? initialManifestation.present : null,
                entrega_inicial: initialManifestation ? initialManifestation.delivery : null,
                // denunciante
                nombre_denunciante: thirdComplainant ? thirdComplainant.name : null,
                apellido1_denunciante: thirdComplainant ? thirdComplainant.surname1 : null,
                apellido2_denunciante: thirdComplainant ? thirdComplainant.surname2 : null,
                identificacion_denunciante: thirdComplainant ? thirdComplainant.document : null,
                telefono1_denunciante: thirdComplainant ? thirdComplainant.phone1 : null,
                telefono2_denunciante: thirdComplainant ? thirdComplainant.phone2 : null,
                fec_nac_denunciante: thirdComplainant ? dateLocalInputFormatter(thirdComplainant.birthday) : null,
                correo_denunciante: thirdComplainant ? thirdComplainant.email : null,
                tipo_via_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetTypeId != null ? await this.getName(thirdComplainantAddress.streetTypeId) : null,
                nombre_via_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetId != null ? await this.getName(thirdComplainantAddress.streetId) : null,
                numero_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.number != null ? thirdComplainantAddress.number : null,
                municipio_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.municipalityId != null ? await this.getName(thirdComplainantAddress.municipalityId) : null,
                zona_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.districId != null ? await this.getName(thirdComplainantAddress.districId) : null,
                //colegiado
                nombre_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.name : null,
                apellido1_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.surname1 : null,
                apellido2_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.surname2 : null,
                identificación_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.document : null,
                telefono1_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.phone1 : null,
                telefono2_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.phone2 : null,
                correo_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.email : null,
                num_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetTypeId != null ? await this.getName(collegiateComplainantAddress.streetTypeId) : null,
                nombre_via_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetId != null ? await this.getName(collegiateComplainantAddress.streetId) : null,
                numero_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.number != null ? collegiateComplainantAddress.number : null,
                municipio_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.municipalityId != null ? await this.getName(collegiateComplainantAddress.municipalityId) : null,
                zona_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.districId != null ? await this.getName(collegiateComplainantAddress.districId) : null,
                fecha_manifestacion_denunciante: complainant ? dateLocalInputFormatter(complainant.dateCreated) : null,
                hora_manifestacion_denunciante: complainant ? dateTimeInputFormatter(complainant.dateCreated) : null,
                manifestacion_denunciante: complainant ? complainant.manifestation : null,
                presenta_denunciante: complainant ? complainant.present : null,
                entrega_denunciante: complainant ? complainant.delivery : null,
                justicia_gratuita_denunciante: complainantGeneral ? complainantGeneral.freeJustice == false ? 'no' : 'si' : null,
                parte_causa: complainantGeneral ? complainantGeneral.showPartCause == false ? 'no' : 'si' : null,
                renuncia_reparacion: complainantGeneral ? complainantGeneral.resignationRepairDamage == false ? 'no' : 'si' : null,
                sospecha_persona: complainantGeneral ? complainantGeneral.suspectSomeone == false ? 'no' : 'si' : null,
                abogado_denunciante: complainantGeneral ? complainantGeneral.appointsLawyer == false ? 'no' : 'si' : null,
                renuncia_restitucion: complainantGeneral ? complainantGeneral.resignationRestitutionCause == false ? 'no' : 'si' : null,
                renuncia_indemnizacion: complainantGeneral ? complainantGeneral.indemnificationWaiver == false ? 'no' : 'si' : null,
                denuncio_previo: complainantGeneral ? complainantGeneral.denouncePreviously == false ? 'no' : 'si' : null,
                parte_facultativo_denunciante: complainantGeneral ? complainantGeneral.lawyerPart : null,
                //vehiculo
                vehiculo_denunciante: complainantCar ? complainantCar.plate : null,
                tipo_vehiculo_denunciante: complainantCar ? await this.getName(complainantCar.vehicleType) : null,
                marca_vehiculo_denunciante: complainantCar ? await this.getName(complainantCar.markId) : null,
                modelo_vehiculo_denunciante: complainantCar ? await this.getName(complainantCar.modelId) : null,
                aseguradora_denunciante: complainantCar ? await this.getName(complainantCar.insuranceCarrierId) : null,
                n_poliza_denunciante: complainantCar ? complainantCar.policyNumber : null,
                n_bastidor: complainantCar ? complainantCar.frame : null,
                fecha_matriculacion: complainantCar ? dateLocalInputFormatter(complainantCar.plateDate) : null,
                fecha_val_poliza_denunciante: complainantCar ? dateLocalInputFormatter(complainantCar.validityPolicy) : null,
                fecha_val_inspeccion_denunciante: complainantCar ? dateLocalInputFormatter(complainantCar.validityInpeccion) : null,
                desperfecto_vehiculo: complainantGeneral ? complainantGeneral.vehicleDamage : null,
                matricula_remolque: complainantGeneral ? complainantGeneral.trailerPlate : null,
                seguro: complainantGeneral ? complainantGeneral.ownsSecurity == false ? 'no' : 'si' : null,
                //tomador del seguro
                nombre_tomador_denunciante: insuranceTaker ? insuranceTaker.name : null,
                apellido1_tomador_denunciante: insuranceTaker ? insuranceTaker.surname1 : null,
                apellido2_tomador_denunciante: insuranceTaker ? insuranceTaker.surname2 : null,
                identificacion_tomador_denunciante: insuranceTaker ? insuranceTaker.document : null,
                telefono1_tomador_denunciante: insuranceTaker ? insuranceTaker.phone1 : null,
                telefono2_tomador_denunciante: insuranceTaker ? insuranceTaker.phone2 : null,
                correo_tomador_denunciante: insuranceTaker ? insuranceTaker.email : null,
                //direccion tomador
                tipo_via_tomador_denunciante: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.streetTypeId != null ? await this.getName(insuranceTakerAddress.streetTypeId) : null,
                nombre_via_tomador_denunciante: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.streetId != null ? await this.getName(insuranceTakerAddress.streetId) : null,
                numero_tomador_denunciante: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.number != null ? insuranceTakerAddress.number : null,
                municipio_tomador_denunciante: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.municipalityId != null ? await this.getName(insuranceTakerAddress.municipalityId) : null,
                zona_tomador_denunciante: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.districId != null ? await this.getName(insuranceTakerAddress.districId) : null,
                //propietario del vehículo
                nombre_propietario_denunciante: carOwner ? carOwner.name : null,
                apellido1_propietario_denunciante: carOwner ? carOwner.surname1 : null,
                apellido2_propietario_denunciante: carOwner ? carOwner.surname2 : null,
                identificacion_propietario_denunciante: carOwner ? carOwner.document : null,
                telefono1_propietario_denunciante: carOwner ? carOwner.phone1 : null,
                telefono2_propietario_denunciante: carOwner ? carOwner.phone2 : null,
                correo_propietario_denunciante: carOwner ? carOwner.email : null,
                //direccion propietario
                tipo_via_propietario_denunciante: carOwnerAddress instanceof Direction && carOwnerAddress.streetTypeId != null ? await this.getName(carOwnerAddress.streetTypeId) : null,
                nombre_via_propietario_denunciante: carOwnerAddress instanceof Direction && carOwnerAddress.streetId != null ? await this.getName(carOwnerAddress.streetId) : null,
                numero_propietario_denunciante: carOwnerAddress instanceof Direction && carOwnerAddress.number != null ? carOwnerAddress.number : null,
                municipio_propietario_denunciante: carOwnerAddress instanceof Direction && carOwnerAddress.municipalityId != null ? await this.getName(carOwnerAddress.municipalityId) : null,
                zona_propietario_denunciante: carOwnerAddress instanceof Direction && carOwnerAddress.districId != null ? await this.getName(carOwnerAddress.districId) : null,
                // denunciado
                nombre_denunciado: thirdDenounced ? thirdDenounced.name : null,
                apellido1_denunciado: thirdDenounced ? thirdDenounced.surname1 : null,
                apellido2_denunciado: thirdDenounced ? thirdDenounced.surname2 : null,
                identificacion_denunciado: thirdDenounced ? thirdDenounced.document : null,
                telefono1_denunciado: thirdDenounced ? thirdDenounced.phone1 : null,
                telefono2_denunciado: thirdDenounced ? thirdDenounced.phone2 : null,
                fec_nac_denunciado: thirdDenounced ? dateLocalInputFormatter(thirdDenounced.birthday) : null,
                correo_denunciado: thirdDenounced ? thirdDenounced.email : null,
                tipo_via_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetTypeId != null ? await this.getName(thirdDenouncedAddress.streetTypeId) : null,
                nombre_via_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetId != null ? await this.getName(thirdDenouncedAddress.streetId) : null,
                numero_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.number != null ? thirdDenouncedAddress.number : null,
                municipio_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.municipalityId != null ? await this.getName(thirdDenouncedAddress.municipalityId) : null,
                zona_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.districId != null ? await this.getName(thirdDenouncedAddress.districId) : null,
                //colegiado
                nombre_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.name : null,
                apellido1_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.surname1 : null,
                apellido2_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.surname2 : null,
                identificación_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.document : null,
                telefono1_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.phone1 : null,
                telefono2_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.phone2 : null,
                correo_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.email : null,
                num_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetTypeId != null ? await this.getName(collegiateDenouncedAddress.streetTypeId) : null,
                nombre_via_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetId != null ? await this.getName(collegiateDenouncedAddress.streetId) : null,
                numero_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.number != null ? collegiateDenouncedAddress.number : null,
                municipio_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.municipalityId != null ? await this.getName(collegiateDenouncedAddress.municipalityId) : null,
                zona_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.districId != null ? await this.getName(collegiateDenouncedAddress.districId) : null,
                fecha_manifestacion_denunciado: denounced ? dateLocalInputFormatter(denounced.dateCreated) : null,
                hora_manifestacion_denunciado: denounced ? dateTimeInputFormatter(denounced.dateCreated) : null,
                manifestacion_denunciado: denounced ? denounced.manifestation : null,
                presenta_denunciado: denounced ? denounced.present : null,
                entrega_denunciado: denounced ? denounced.delivery : null,
                declara: denouncedGeneral ? denouncedGeneral.wantToDeclare == false ? 'no' : 'si' : null,
                notifica_familia: denouncedGeneral ? denouncedGeneral.familyNotice == false ? 'no' : 'si' : null,
                examen_medico: denouncedGeneral ? denouncedGeneral.medicalExamination == false ? 'no' : 'si' : null,
                abogado_denunciado: denouncedGeneral ? denouncedGeneral.appointLawyer == false ? 'no' : 'si' : null,
                abogado_oficio_denunciado: denouncedGeneral ? denouncedGeneral.publicDefender == false ? 'no' : 'si' : null,
                parte_facultativo_denunciado: denouncedGeneral ? denouncedGeneral.optionalPart : null,
                armas: denouncedGeneral ? denouncedGeneral.own_arms == false ? 'no' : 'si' : null,
                conoce_denunciante: denouncedGeneral ? denouncedGeneral.meetWhistleblower == false ? 'no' : 'si' : null,
                relacion_denunciante: denouncedGeneral ? denouncedGeneral.relationshipWithComplainant == false ? 'no' : 'si' : null,
                // testigos
                nombre_testigo: thirdWitness ? thirdWitness.name : '',
                apellido1_testigo: thirdWitness ? thirdWitness.surname1 : null,
                apellido2_testigo: thirdWitness ? thirdWitness.surname2 : null,
                identificacion_testigo: thirdWitness ? thirdWitness.document : null,
                telefono1_testigo: thirdWitness ? thirdWitness.phone1 : null,
                telefono2_testigo: thirdWitness ? thirdWitness.phone2 : null,
                fec_nac_testigo: thirdWitness ? dateLocalInputFormatter(thirdWitness.birthday) : null,
                correo_testigo: thirdWitness ? thirdWitness.email : null,
                tipo_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetTypeId != null ? await this.getName(thirdWitnessAddress.streetTypeId) : null,
                nombre_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetId != null ? await this.getName(thirdWitnessAddress.streetId) : null,
                numero_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.number != null ? thirdWitnessAddress.number : null,
                municipio_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.municipalityId != null ? await this.getName(thirdWitnessAddress.municipalityId) : null,
                zona_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.districId != null ? await this.getName(thirdWitnessAddress.districId) : null,
                fecha_manifestacion_testigo: witness ? dateLocalInputFormatter(witness.date) : '',
                hora_manifestacion_testigo: witness ? dateTimeInputFormatter(witness.date) : '',
                manifestacion_testigo: witness ? witness.manifestacion : '',
                presenta_testigo: witness ? witness.presents : '',
                // representante legal
                nombre_representante: thirdLegalGuardian ? thirdLegalGuardian.name : '',
                apellido1_representante: thirdLegalGuardian ? thirdLegalGuardian.surname1 : null,
                apellido2_representante: thirdLegalGuardian ? thirdLegalGuardian.surname2 : null,
                identificacion_representante: thirdLegalGuardian ? thirdLegalGuardian.document : null,
                telefono1_representante: thirdLegalGuardian ? thirdLegalGuardian.phone1 : null,
                telefono2_representante: thirdLegalGuardian ? thirdLegalGuardian.phone2 : null,
                fec_nac_representante: thirdLegalGuardian ? dateLocalInputFormatter(thirdLegalGuardian.birthday) : null,
                correo_representante: thirdLegalGuardian ? thirdLegalGuardian.email : null,
                tipo_via_representante: thirdLegalGuardianAddress instanceof Direction && thirdLegalGuardianAddress.streetTypeId != null ? await this.getName(thirdLegalGuardianAddress.streetTypeId) : null,
                nombre_via_representante: thirdLegalGuardianAddress instanceof Direction && thirdLegalGuardianAddress.streetId != null ? await this.getName(thirdLegalGuardianAddress.streetId) : null,
                numero_representante: thirdLegalGuardianAddress instanceof Direction && thirdLegalGuardianAddress.number != null ? thirdLegalGuardianAddress.number : null,
                municipio_representante: thirdLegalGuardianAddress instanceof Direction && thirdLegalGuardianAddress.municipalityId != null ? await this.getName(thirdLegalGuardianAddress.municipalityId) : null,
                zona_representante: thirdLegalGuardianAddress instanceof Direction && thirdLegalGuardianAddress.districId != null ? await this.getName(thirdLegalGuardianAddress.districId) : null,
                fecha_manifestacion_representante: legalGuardian ? dateLocalInputFormatter(legalGuardian.date_time) : '',
                hora_manifestacion_representante: legalGuardian ? dateTimeInputFormatter(legalGuardian.date_time) : '',
                // manifestacion final
                m_policia_final: policeFinal ? policeFinal.name : '',
                fecha_manifestacion_final: finalManifestation.dateCreated != null ? dateLocalInputFormatter(finalManifestation.dateCreated) : '',
                hora_manifestacion_final: finalManifestation.dateCreated != null ? dateTimeInputFormatter(finalManifestation.dateCreated) : '',
                fecha_cita_final: finalManifestation.dateAppointment != null ? dateLocalInputFormatter(finalManifestation.dateAppointment) : '',
                hora_cita_final: finalManifestation.dateAppointment != null ? dateTimeInputFormatter(finalManifestation.dateAppointment) : '',
                manifestacion_final: finalManifestation ? finalManifestation.manifestation : null,
                presenta_final: finalManifestation ? finalManifestation.present : null,
                entrega_final: finalManifestation ? finalManifestation.delivery : null,
                inspeccion: manifestationGeneral ? manifestationGeneral.ocularInspection == false ? 'no' : 'si' : null,
                resultado_inspeccion: manifestationGeneral ? manifestationGeneral.eyeInspectionResult : null,
                muestras: manifestationGeneral ? manifestationGeneral.samplesInvolved == false ? 'no' : 'si' : null,
                tipos_muestras: manifestationGeneral ? manifestationGeneral.sampleTypes : null,
                armas_manifestacion: manifestationGeneral ? manifestationGeneral.weaponsIntervene == false ? 'no' : 'si' : null,
                tramite_retirada_armas: manifestationGeneral ? manifestationGeneral.armsWithdrawalProcedure == false ? 'no' : 'si' : null,
                tipos_armas: manifestationGeneral ? manifestationGeneral.typesWeapons : null,
                datos_interes: manifestationGeneral ? manifestationGeneral.interestingData : null,
                observaciones: manifestationGeneral ? manifestationGeneral.observations : null,
                traslado_medico: manifestationGeneral ? manifestationGeneral.transferHealthCenter == false ? 'no' : 'si' : null,
                acompanar_domicilio: manifestationGeneral ? manifestationGeneral.accompanyAddressEffects == false ? 'no' : 'si' : null,
                traslado_casa_familiar: manifestationGeneral ? manifestationGeneral.accompanyFamilyHome == false ? 'no' : 'si' : null,
                centro_acogida: manifestationGeneral ? manifestationGeneral.transferReceptionCenter == false ? 'no' : 'si' : null,
                n_folio_remision: manifestationGeneral ? manifestationGeneral.numFoliosRemission : null,
                fecha_remision: manifestationGeneral ? manifestationGeneral.referralDate != null ? dateLocalInputFormatter(manifestationGeneral.referralDate) : '' : null,
                acta_independizada: manifestationGeneral ? manifestationGeneral.independentMinutes : null,
                citaciones: manifestationGeneral ? manifestationGeneral.citations : null,
                cuerpo_traspaso: manifestationGeneral ? manifestationGeneral.bodyTransfer : null
            };
        }
        catch (error) {
            console.log(error);
        }
        try {
            await fileServices.downloadFile(diligence.diligenceTypeId, diligence.diligenceNumber, data, file);
        }
        catch (error) {
            console.log(error);
        }
    }
    async writeActFile(diligence, initialManifestation, finalManifestation, file, complainantId, denouncedId, witnessId) {
        let data, subtype, denouncedActa, complainantActa, policeInitial, thirdComplainant, complainant, collegiateComplainant, denounced, thirdDenounced, collegiateDenounced, witness, thirdWitness, policeFinal, law, lawArticle, bussiness, bussinessAddress, bussinessFullAddress, thirdComplainantAddress, thirdDenouncedAddress, thirdWitnessAddress, denouncedCar, carOwner, carOwnerAddress, insuranceTaker, insuranceTakerAddress, collegiateComplainantAddress, collegiateDenouncedAddress, thirdDenouncedInfractionAddress;
        if (diligence.subDiligenceTypeId != null) {
            subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);
        }
        if (initialManifestation.userId != null) {
            policeInitial = await usersService.findOne(initialManifestation.userId);
        }
        if (finalManifestation.userId != null) {
            policeFinal = await usersService.findOne(finalManifestation.userId);
        }
        try {
            if (denouncedId)
                denouncedActa = await denouncedActaService.findOne(diligence.id, denouncedId);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainantActa = await complainantActaService.findOne(diligence.id, complainantId);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (complainantId)
                complainant = await complainantService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (denouncedId)
                denounced = await denouncedService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witnessId)
                witness = await witnessService.findOne(witnessId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        //third complainant information
        try {
            if (complainantActa) {
                thirdComplainant = await thirdsService.findOne(complainantActa.complainantThirId);
            }
        }
        catch (error) {
            console.log(error);
        }
        if (complainant) {
            try {
                if (complainant.collegiate) {
                    collegiateComplainant = await thirdsService.findOne(complainant.collegiate);
                    collegiateComplainantAddress = new Direction(await directionsService.findOne(collegiateComplainant.addressId));
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        try {
            if (thirdComplainant) {
                thirdComplainantAddress = new Direction(await directionsService.findOne(thirdComplainant.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        // third denounced information
        try {
            if (denouncedActa) {
                thirdDenounced = await thirdsService.findOne(denouncedActa.denouncedThirId);
                if (denouncedActa.directionId) {
                    thirdDenouncedInfractionAddress = new Direction(await directionsService.findOne(denouncedActa.directionId));
                }
            }
        }
        catch (error) {
            console.log(error);
        }
        if (denounced) {
            try {
                if (denounced.collegiate) {
                    collegiateDenounced = await thirdsService.findOne(denounced.collegiate);
                    collegiateDenouncedAddress = new Direction(await directionsService.findOne(collegiateDenounced.addressId));
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        try {
            if (thirdDenounced) {
                thirdDenouncedAddress = new Direction(await directionsService.findOne(thirdDenounced.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (denouncedActa) {
                denouncedCar = await vehiclesService.findOne(denouncedActa.vehicleId);
                if (denouncedCar.thirdId) {
                    carOwner = await thirdsService.findOne(denouncedCar.thirdId);
                    carOwnerAddress = new Direction(await directionsService.findOne(carOwner.addressId));
                }
                if (denouncedCar.insuranceTakerId) {
                    insuranceTaker = await thirdsService.findOne(denouncedCar.insuranceTakerId);
                    insuranceTakerAddress = new Direction(await directionsService.findOne(insuranceTaker.addressId));
                }
            }
        }
        catch (error) {
            console.log(error);
        }
        // third witness information
        try {
            if (witness) {
                thirdWitness = await thirdsService.findOne(witness.witnessThird);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witness) {
                thirdWitnessAddress = new Direction(await directionsService.findOne(thirdWitness.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        //laws ans articles
        try {
            if (complainantActa) {
                law = await lawService.findOne(complainantActa.lawId);
            }
            if (complainantActa) {
                lawArticle = await lawArticleService.findOne(complainantActa.articleId);
            }
        }
        catch (error) {
            console.log(error);
        }
        //business
        try {
            if (denouncedActa) {
                try {
                    bussiness = await bussinessService.findOne(denouncedActa.bussinessId);
                    if (bussiness) {
                        bussinessAddress = new Direction(await directionsService.findOne(bussiness.directionId));
                    }
                    if (bussinessAddress instanceof Direction) {
                        bussinessFullAddress =
                            await this.getName(bussinessAddress.streetTypeId) + ' ' +
                                await this.getName(bussinessAddress.streetId) + ', ' +
                                bussinessAddress.number + '. ' +
                                await this.getName(bussinessAddress.municipalityId);
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            data = {
                n_diligencia: diligence ? diligence.diligenceNumber : '',
                fecha_diligencia: diligence ? dateLocalInputFormatter(diligence.entryDate) : '',
                hora_diligencia: diligence ? dateTimeInputFormatter(diligence.entryDate) : '',
                n_instructor: diligence.instructorId != null ? await this.getName(diligence.instructorId) : '',
                n_secretario: diligence.secretaryId != null ? await this.getName(diligence.secretaryId) : '',
                n_expediente: diligence ? diligence.proceedingsNumber : '',
                tipo_diligencia: diligence.diligenceTypeId != null ? await this.getName(diligence.diligenceTypeId) : '',
                subtipo_diligencia: subtype ? subtype.subTypeDiligence : '',
                remision: diligence.courtId != null ? await this.getName(diligence.courtId) : '',
                //manifestacion inicial
                m_policia_inicial: policeInitial ? policeInitial.name : '',
                fecha_manifestacion_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateCreated) : '',
                hora_manifestacion_inicial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateCreated) : '',
                fecha_cita_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateAppointment) : '',
                hora_cita_incial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateAppointment) : '',
                manifestacion_inicial: initialManifestation ? initialManifestation.manifestation : '',
                presenta_inicial: initialManifestation ? initialManifestation.present : '',
                entrega_inicial: initialManifestation ? initialManifestation.delivery : '',
                // denunciante
                nombre_denunciante: thirdComplainant ? thirdComplainant.name : '',
                apellido1_denunciante: thirdComplainant ? thirdComplainant.surname1 : '',
                apellido2_denunciante: thirdComplainant ? thirdComplainant.surname2 : '',
                identificacion_denunciante: thirdComplainant ? thirdComplainant.document : '',
                telefono1_denunciante: thirdComplainant ? thirdComplainant.phone1 : '',
                telefono2_denunciante: thirdComplainant ? thirdComplainant.phone2 : '',
                fec_nac_denunciante: thirdComplainant ? dateLocalInputFormatter(thirdComplainant.birthday) : '',
                correo_denunciante: thirdComplainant ? thirdComplainant.email : '',
                tipo_via_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetTypeId != null ? await this.getName(thirdComplainantAddress.streetTypeId) : '',
                nombre_via_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetId != null ? await this.getName(thirdComplainantAddress.streetId) : '',
                numero_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.number != null ? thirdComplainantAddress.number : '',
                municipio_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.municipalityId != null ? await this.getName(thirdComplainantAddress.municipalityId) : '',
                zona_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.districId != null ? await this.getName(thirdComplainantAddress.districId) : '',
                //colegiado
                nombre_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.name : '',
                apellido1_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.surname1 : '',
                apellido2_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.surname2 : '',
                identificación_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.document : '',
                telefono1_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.phone1 : '',
                telefono2_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.phone2 : '',
                correo_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.email : '',
                num_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.collegiate_num : '',
                //direccion colegiado
                tipo_via_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetTypeId != null ? await this.getName(collegiateComplainantAddress.streetTypeId) : '',
                nombre_via_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetId != null ? await this.getName(collegiateComplainantAddress.streetId) : '',
                numero_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.number != null ? collegiateComplainantAddress.number : '',
                municipio_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.municipalityId != null ? await this.getName(collegiateComplainantAddress.municipalityId) : '',
                zona_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.districId != null ? await this.getName(collegiateComplainantAddress.districId) : '',
                fecha_manifestacion_denunciante: complainant ? dateLocalInputFormatter(complainant.dateCreated) : '',
                hora_manifestacion_denunciante: complainant ? dateTimeInputFormatter(complainant.dateCreated) : '',
                manifestacion_denunciante: complainant ? complainant.manifestation : '',
                presenta_denunciante: complainant ? complainant.present : '',
                entrega_denunciante: complainant ? complainant.delivery : '',
                ley: law ? law.law : '',
                articulo: lawArticle ? lawArticle.article : '',
                material: complainantActa ? complainantActa.intervenedMaterial : '',
                // denunciado
                nombre_denunciado: thirdDenounced ? thirdDenounced.name : '',
                apellido1_denunciado: thirdDenounced ? thirdDenounced.surname1 : '',
                apellido2_denunciado: thirdDenounced ? thirdDenounced.surname2 : '',
                identificacion_denunciado: thirdDenounced ? thirdDenounced.document : '',
                telefono1_denunciado: thirdDenounced ? thirdDenounced.phone1 : '',
                telefono2_denunciado: thirdDenounced ? thirdDenounced.phone2 : '',
                fec_nac_denunciado: thirdDenounced ? dateInputFormatter(thirdDenounced.birthday) : '',
                correo_denunciado: thirdDenounced ? thirdDenounced.email : '',
                tipo_via_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetTypeId != null ? await this.getName(thirdDenouncedAddress.streetTypeId) : '',
                nombre_via_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetId != null ? await this.getName(thirdDenouncedAddress.streetId) : '',
                numero_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.number != null ? thirdDenouncedAddress.number : '',
                municipio_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.municipalityId != null ? await this.getName(thirdDenouncedAddress.municipalityId) : '',
                zona_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.districId != null ? await this.getName(thirdDenouncedAddress.districId) : '',
                //colegiado
                nombre_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.name : '',
                apellido1_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.surname1 : '',
                apellido2_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.surname2 : '',
                identificación_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.document : '',
                telefono1_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.phone1 : '',
                telefono2_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.phone2 : '',
                correo_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.email : '',
                num_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.collegiate_num : '',
                //lugar infracción
                tipo_via_infraccion: thirdDenouncedInfractionAddress instanceof Direction && thirdDenouncedInfractionAddress.streetTypeId != null ? await this.getName(thirdDenouncedInfractionAddress.streetTypeId) : '',
                nombre_via_infraccion: thirdDenouncedInfractionAddress instanceof Direction && thirdDenouncedInfractionAddress.streetId != null ? await this.getName(thirdDenouncedInfractionAddress.streetId) : '',
                //direccion colegiado
                tipo_via_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetTypeId != null ? await this.getName(collegiateDenouncedAddress.streetTypeId) : '',
                nombre_via_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetId != null ? await this.getName(collegiateDenouncedAddress.streetId) : '',
                numero_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.number != null ? collegiateDenouncedAddress.number : '',
                municipio_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.municipalityId != null ? await this.getName(collegiateDenouncedAddress.municipalityId) : '',
                zona_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.districId != null ? await this.getName(collegiateDenouncedAddress.districId) : '',
                fecha_manifestacion_denunciado: denounced ? dateInputFormatter(denounced.dateCreated) : '',
                hora_manifestacion_denunciado: denounced ? dateTimeInputFormatter(denounced.dateCreated) : '',
                manifestacion_denunciado: denounced ? denounced.manifestation : '',
                presenta_denunciado: denounced ? denounced.present : '',
                entrega_denunciado: denounced ? denounced.delivery : '',
                empresa: bussinessAddress ? bussinessFullAddress : '',
                direccion: bussiness ? bussiness.name : '',
                matricula_trailer: denouncedActa ? denouncedActa.trailerPlate : '',
                vehiculo_denunciado: denouncedCar ? denouncedCar.plate : '',
                tipo_vehiculo_denunciado: denouncedCar ? await this.getName(denouncedCar.vehicleType) : '',
                marca_vehiculo_denunciado: denouncedCar ? await this.getName(denouncedCar.markId) : '',
                modelo_vehiculo_denunciado: denouncedCar ? await this.getName(denouncedCar.modelId) : '',
                aseguradora_denunciado: denouncedCar ? await this.getName(denouncedCar.insuranceCarrierId) : '',
                n_poliza_denunciado: denouncedCar ? denouncedCar.policyNumber : '',
                n_bastidor: denouncedCar ? denouncedCar.frame : '',
                fecha_matriculacion: denouncedCar ? dateLocalInputFormatter(denouncedCar.plateDate) : '',
                fecha_val_poliza_denunciado: denouncedCar ? dateLocalInputFormatter(denouncedCar.validityPolicy) : '',
                fecha_val_inspeccion_denunciado: denouncedCar ? dateLocalInputFormatter(denouncedCar.validityInpeccion) : '',
                danos_vehiculo: denouncedActa ? denouncedActa.vehicleDamage : '',
                //tomador del seguro
                nombre_tomador_denunciado: insuranceTaker ? insuranceTaker.name : '',
                apellido1_tomador_denunciado: insuranceTaker ? insuranceTaker.surname1 : '',
                apellido2_tomador_denunciado: insuranceTaker ? insuranceTaker.surname2 : '',
                identificacion_tomador_denunciado: insuranceTaker ? insuranceTaker.document : '',
                telefono1_tomador_denunciado: insuranceTaker ? insuranceTaker.phone1 : '',
                telefono2_tomador_denunciado: insuranceTaker ? insuranceTaker.phone2 : '',
                correo_tomador_denunciado: insuranceTaker ? insuranceTaker.email : '',
                //direccion tomador
                tipo_via_tomador_denunciado: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.streetTypeId != null ? await this.getName(insuranceTakerAddress.streetTypeId) : '',
                nombre_via_tomador_denunciado: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.streetId != null ? await this.getName(insuranceTakerAddress.streetId) : '',
                numero_tomador_denunciado: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.number != null ? insuranceTakerAddress.number : '',
                municipio_tomador_denunciado: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.municipalityId != null ? await this.getName(insuranceTakerAddress.municipalityId) : '',
                zona_tomador_denunciado: insuranceTakerAddress instanceof Direction && insuranceTakerAddress.districId != null ? await this.getName(insuranceTakerAddress.districId) : '',
                //propietario del vehículo
                nombre_propietario_denunciado: carOwner ? carOwner.name : '',
                apellido1_propietario_denunciado: carOwner ? carOwner.surname1 : '',
                apellido2_propietario_denunciado: carOwner ? carOwner.surname2 : '',
                identificacion_propietario_denunciado: carOwner ? carOwner.document : '',
                telefono1_propietario_denunciado: carOwner ? carOwner.phone1 : '',
                telefono2_propietario_denunciado: carOwner ? carOwner.phone2 : '',
                correo_propietario_denunciado: carOwner ? carOwner.email : '',
                //direccion propietario
                tipo_via_propietario_denunciado: carOwnerAddress instanceof Direction && carOwnerAddress.streetTypeId != null ? await this.getName(carOwnerAddress.streetTypeId) : '',
                nombre_via_propietario_denunciado: carOwnerAddress instanceof Direction && carOwnerAddress.streetId != null ? await this.getName(carOwnerAddress.streetId) : '',
                numero_propietario_denunciado: carOwnerAddress instanceof Direction && carOwnerAddress.number != null ? carOwnerAddress.number : '',
                municipio_propietario_denunciado: carOwnerAddress instanceof Direction && carOwnerAddress.municipalityId != null ? await this.getName(carOwnerAddress.municipalityId) : '',
                zona_propietario_denunciado: carOwnerAddress instanceof Direction && carOwnerAddress.districId != null ? await this.getName(carOwnerAddress.districId) : '',
                // testigos
                nombre_testigo: thirdWitness ? thirdWitness.name : '',
                apellido1_testigo: thirdWitness ? thirdWitness.surname1 : '',
                apellido2_testigo: thirdWitness ? thirdWitness.surname2 : '',
                identificacion_testigo: thirdWitness ? thirdWitness.document : '',
                telefono1_testigo: thirdWitness ? thirdWitness.phone1 : '',
                telefono2_testigo: thirdWitness ? thirdWitness.phone2 : '',
                fec_nac_testigo: thirdWitness ? dateLocalInputFormatter(thirdWitness.birthday) : '',
                correo_testigo: thirdWitness ? thirdWitness.email : '',
                tipo_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetTypeId != null ? await this.getName(thirdWitnessAddress.streetTypeId) : '',
                nombre_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetId != null ? await this.getName(thirdWitnessAddress.streetId) : '',
                numero_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.number != null ? thirdWitnessAddress.number : '',
                municipio_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.municipalityId != null ? await this.getName(thirdWitnessAddress.municipalityId) : '',
                zona_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.districId != null ? await this.getName(thirdWitnessAddress.districId) : '',
                fecha_manifestacion_testigo: witness ? dateLocalInputFormatter(witness.date) : '',
                hora_manifestacion_testigo: witness ? dateTimeInputFormatter(witness.date) : '',
                manifestacion_testigo: witness ? witness.manifestacion : '',
                presenta_testigo: witness ? witness.presents : '',
                // manifestacion final
                m_policia_final: policeFinal ? policeFinal.name : '',
                fecha_manifestacion_final: finalManifestation.dateCreated != null ? dateLocalInputFormatter(finalManifestation.dateCreated) : '',
                hora_manifestacion_final: finalManifestation.dateCreated != null ? dateTimeInputFormatter(finalManifestation.dateCreated) : '',
                fecha_cita_final: finalManifestation.dateAppointment != null ? dateLocalInputFormatter(finalManifestation.dateAppointment) : '',
                hora_cita_final: finalManifestation.dateAppointment != null ? dateTimeInputFormatter(finalManifestation.dateAppointment) : '',
                manifestacion_final: finalManifestation ? finalManifestation.manifestation : '',
                presenta_final: finalManifestation ? finalManifestation.present : '',
                entrega_final: finalManifestation ? finalManifestation.delivery : ''
            };
        }
        catch (error) {
            console.log(error);
        }
        try {
            await fileServices.downloadFile(diligence.diligenceTypeId, diligence.diligenceNumber, data, file);
        }
        catch (error) {
            console.log(error);
        }
    }
    async writeObjectFile(diligence, initialManifestation, finalManifestation, file, complainantId, denouncedId, witnessId) {
        let data, subtype, policeInitial, thirdComplainant, complainant, collegiateComplainant, denounced, thirdDenounced, collegiateDenounced, witness, thirdWitness, policeFinal, thirdComplainantAddress, thirdDenouncedAddress, thirdWitnessAddress, collegiateComplainantAddress, collegiateDenouncedAddress;
        if (diligence.subDiligenceTypeId != null) {
            subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);
        }
        if (initialManifestation.userId != null) {
            policeInitial = await usersService.findOne(initialManifestation.userId);
        }
        if (finalManifestation.userId != null) {
            policeFinal = await usersService.findOne(finalManifestation.userId);
        }
        try {
            if (complainantId)
                complainant = await complainantService.findOne(complainantId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (denouncedId)
                denounced = await denouncedService.findOne(denouncedId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        try {
            if (witnessId)
                witness = await witnessService.findOne(witnessId, diligence.id);
        }
        catch (error) {
            console.log(error);
        }
        // third complainant information
        if (complainant) {
            thirdComplainant = await thirdsService.findOne(complainant.complainantThirId);
        }
        if (complainant) {
            if (complainant.collegiate) {
                collegiateComplainant = await thirdsService.findOne(complainant.collegiate);
                collegiateComplainantAddress = new Direction(await directionsService.findOne(collegiateComplainant.addressId));
            }
        }
        try {
            if (thirdComplainant) {
                thirdComplainantAddress = new Direction(await directionsService.findOne(thirdComplainant.addressId));
            }
        }
        catch (error) {
            console.log(error);
        }
        if (denounced) {
            thirdDenounced = await thirdsService.findOne(denounced.denouncedThirId);
            if (denounced.collegiate != null) {
                collegiateDenounced = await thirdsService.findOne(denounced.collegiate);
                collegiateDenouncedAddress = new Direction(await directionsService.findOne(collegiateDenounced.addressId));
            }
            try {
                thirdDenouncedAddress = new Direction(await directionsService.findOne(thirdDenounced.addressId));
            }
            catch (error) {
                console.log(error);
            }
        }
        if (witness) {
            thirdWitness = await thirdsService.findOne(witness.witnessThird);
            try {
                thirdWitnessAddress = new Direction(await directionsService.findOne(thirdWitness.addressId));
            }
            catch (error) {
                console.log(error);
            }
        }
        try {
            data = {
                n_diligencia: diligence ? diligence.diligenceNumber : null,
                fecha_diligencia: diligence ? dateLocalInputFormatter(diligence.entryDate) : null,
                hora_diligencia: diligence ? dateTimeInputFormatter(diligence.entryDate) : null,
                n_instructor: diligence.instructorId != null ? await this.getName(diligence.instructorId) : null,
                n_secretario: diligence.secretaryId != null ? await this.getName(diligence.secretaryId) : null,
                n_expediente: diligence ? diligence.proceedingsNumber : null,
                tipo_diligencia: diligence.diligenceTypeId != null ? await this.getName(diligence.diligenceTypeId) : null,
                subtipo_diligencia: subtype.subTypeDiligence,
                remision: diligence.courtId != null ? await this.getName(diligence.courtId) : null,
                //manifestacion inicial
                m_policia_inicial: policeInitial ? policeInitial.name : null,
                fecha_manifestacion_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateCreated) : '',
                hora_manifestacion_inicial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateCreated) : '',
                fecha_cita_inicial: initialManifestation ? dateLocalInputFormatter(initialManifestation.dateAppointment) : '',
                hora_cita_incial: initialManifestation ? dateTimeInputFormatter(initialManifestation.dateAppointment) : '',
                manifestacion_inicial: initialManifestation ? initialManifestation.manifestation : null,
                presenta_inicial: initialManifestation ? initialManifestation.present : null,
                entrega_inicial: initialManifestation ? initialManifestation.delivery : null,
                // denunciante
                nombre_denunciante: thirdComplainant ? thirdComplainant.name : null,
                apellido1_denunciante: thirdComplainant ? thirdComplainant.surname1 : null,
                apellido2_denunciante: thirdComplainant ? thirdComplainant.surname2 : null,
                identificacion_denunciante: thirdComplainant ? thirdComplainant.document : null,
                telefono1_denunciante: thirdComplainant ? thirdComplainant.phone1 : null,
                telefono2_denunciante: thirdComplainant ? thirdComplainant.phone2 : null,
                fec_nac_denunciante: thirdComplainant ? dateLocalInputFormatter(thirdComplainant.birthday) : null,
                correo_denunciante: thirdComplainant ? thirdComplainant.email : null,
                tipo_via_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetTypeId != null ? await this.getName(thirdComplainantAddress.streetTypeId) : null,
                nombre_via_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.streetId != null ? await this.getName(thirdComplainantAddress.streetId) : null,
                numero_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.number != null ? thirdComplainantAddress.number : null,
                municipio_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.municipalityId != null ? await this.getName(thirdComplainantAddress.municipalityId) : null,
                zona_denunciante: thirdComplainantAddress instanceof Direction && thirdComplainantAddress.districId != null ? await this.getName(thirdComplainantAddress.districId) : null,
                //colegiado
                nombre_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.name : null,
                apellido1_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.surname1 : null,
                apellido2_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.surname2 : null,
                identificación_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.document : null,
                telefono1_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.phone1 : null,
                telefono2_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.phone2 : null,
                correo_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.email : null,
                num_colegiado_denunciante: collegiateComplainant ? collegiateComplainant.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetTypeId != null ? await this.getName(collegiateComplainantAddress.streetTypeId) : null,
                nombre_via_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.streetId != null ? await this.getName(collegiateComplainantAddress.streetId) : null,
                numero_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.number != null ? collegiateComplainantAddress.number : null,
                municipio_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.municipalityId != null ? await this.getName(collegiateComplainantAddress.municipalityId) : null,
                zona_colegiado_denunciante: collegiateComplainantAddress instanceof Direction && collegiateComplainantAddress.districId != null ? await this.getName(collegiateComplainantAddress.districId) : null,
                fecha_manifestacion_denunciante: complainant ? dateLocalInputFormatter(complainant.dateCreated) : null,
                hora_manifestacion_denunciante: complainant ? dateTimeInputFormatter(complainant.dateCreated) : null,
                manifestacion_denunciante: complainant ? complainant.manifestation : null,
                presenta_denunciante: complainant ? complainant.present : null,
                entrega_denunciante: complainant ? complainant.delivery : null,
                // denunciado
                nombre_denunciado: thirdDenounced ? thirdDenounced.name : null,
                apellido1_denunciado: thirdDenounced ? thirdDenounced.surname1 : null,
                apellido2_denunciado: thirdDenounced ? thirdDenounced.surname2 : null,
                identificacion_denunciado: thirdDenounced ? thirdDenounced.document : null,
                telefono1_denunciado: thirdDenounced ? thirdDenounced.phone1 : null,
                telefono2_denunciado: thirdDenounced ? thirdDenounced.phone2 : null,
                fec_nac_denunciado: thirdDenounced ? dateLocalInputFormatter(thirdDenounced.birthday) : null,
                correo_denunciado: thirdDenounced ? thirdDenounced.email : null,
                tipo_via_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetTypeId != null ? await this.getName(thirdDenouncedAddress.streetTypeId) : null,
                nombre_via_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.streetId != null ? await this.getName(thirdDenouncedAddress.streetId) : null,
                numero_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.number != null ? thirdDenouncedAddress.number : null,
                municipio_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.municipalityId != null ? await this.getName(thirdDenouncedAddress.municipalityId) : null,
                zona_denunciado: thirdDenouncedAddress instanceof Direction && thirdDenouncedAddress.districId != null ? await this.getName(thirdDenouncedAddress.districId) : null,
                //colegiado
                nombre_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.name : null,
                apellido1_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.surname1 : null,
                apellido2_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.surname2 : null,
                identificación_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.document : null,
                telefono1_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.phone1 : null,
                telefono2_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.phone2 : null,
                correo_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.email : null,
                num_colegiado_denunciado: collegiateDenounced ? collegiateDenounced.collegiate_num : null,
                //direccion colegiado
                tipo_via_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetTypeId != null ? await this.getName(collegiateDenouncedAddress.streetTypeId) : null,
                nombre_via_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.streetId != null ? await this.getName(collegiateDenouncedAddress.streetId) : null,
                numero_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.number != null ? collegiateDenouncedAddress.number : null,
                municipio_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.municipalityId != null ? await this.getName(collegiateDenouncedAddress.municipalityId) : null,
                zona_colegiado_denunciado: collegiateDenouncedAddress instanceof Direction && collegiateDenouncedAddress.districId != null ? await this.getName(collegiateDenouncedAddress.districId) : null,
                fecha_manifestacion_denunciado: denounced ? dateLocalInputFormatter(denounced.dateCreated) : null,
                hora_manifestacion_denunciado: denounced ? dateTimeInputFormatter(denounced.dateCreated) : null,
                manifestacion_denunciado: denounced ? denounced.manifestation : null,
                presenta_denunciado: denounced ? denounced.present : null,
                entrega_denunciado: denounced ? denounced.delivery : null,
                // testigos
                nombre_testigo: thirdWitness ? thirdWitness.name : null,
                apellido1_testigo: thirdWitness ? thirdWitness.surname1 : null,
                apellido2_testigo: thirdWitness ? thirdWitness.surname2 : null,
                identificacion_testigo: thirdWitness ? thirdWitness.document : null,
                telefono1_testigo: thirdWitness ? thirdWitness.phone1 : null,
                telefono2_testigo: thirdWitness ? thirdWitness.phone2 : null,
                fec_nac_testigo: thirdWitness ? dateLocalInputFormatter(thirdWitness.birthday) : null,
                correo_testigo: thirdWitness ? thirdWitness.email : null,
                tipo_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetTypeId != null ? await this.getName(thirdWitnessAddress.streetTypeId) : null,
                nombre_via_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.streetId != null ? await this.getName(thirdWitnessAddress.streetId) : null,
                numero_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.number != null ? thirdWitnessAddress.number : null,
                municipio_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.municipalityId != null ? await this.getName(thirdWitnessAddress.municipalityId) : null,
                zona_testigo: thirdWitnessAddress instanceof Direction && thirdWitnessAddress.districId != null ? await this.getName(thirdWitnessAddress.districId) : null,
                fecha_manifestacion_testigo: witness ? dateLocalInputFormatter(witness.date) : null,
                hora_manifestacion_testigo: witness ? dateTimeInputFormatter(witness.date) : null,
                manifestacion_testigo: witness ? witness.manifestacion : null,
                presenta_testigo: witness ? witness.presents : null,
                // manifestacion final
                m_policia_final: policeFinal ? policeFinal.name : null,
                fecha_manifestacion_final: finalManifestation.dateCreated != null ? dateLocalInputFormatter(finalManifestation.dateCreated) : '',
                hora_manifestacion_final: finalManifestation.dateCreated != null ? dateTimeInputFormatter(finalManifestation.dateCreated) : '',
                fecha_cita_final: finalManifestation.dateAppointment != null ? dateLocalInputFormatter(finalManifestation.dateAppointment) : '',
                hora_cita_final: finalManifestation.dateAppointment != null ? dateTimeInputFormatter(finalManifestation.dateAppointment) : '',
                manifestacion_final: finalManifestation ? finalManifestation.manifestation : null,
                presenta_final: finalManifestation ? finalManifestation.present : null,
                entrega_final: finalManifestation ? finalManifestation.delivery : null
            };
        }
        catch (error) {
            console.log(error);
        }
        try {
            await fileServices.downloadFile(diligence.diligenceTypeId, diligence.diligenceNumber, data, file);
        }
        catch (error) {
            console.log(error);
        }
    }
    async writeInOutFile(register, file) {
        let data;
        let third = await thirdsService.findOne(register.thirdId);
        try {
            let destination, content, procedence, thirdAddress, agentData, signer;
            if (register.origin != null) {
                procedence = await procedencesService.findOne(register.origin);
            }
            if (register.destination != null) {
                destination = await procedencesService.findOne(register.destination);
            }
            if (register.content != null) {
                content = await containsService.findOne(register.content);
            }
            try {
                thirdAddress = await directionsService.findOne(third.addressId);
            }
            catch (error) {
                console.log(error);
            }
            if (register.agentId != null) {
                agentData = (await usersService.findOneByAgentId(register.agentId)).getState();
            }
            signer = await usersService.findUserSigner();
            try {
                data = {
                    fecha_reg_salida: register.outDate != null ? dateLocalInputFormatter(register.outDate) : null,
                    n_reg_salida: register.outRegisterNumber != null ? register.outRegisterNumber : null,
                    destinatario: destination != null ? destination.name : null,
                    contenido: content != null ? content.name : null,
                    firmante: signer ? signer.name + ' ' + signer.surname1 + ' ' + signer.surname2 : null,
                    fecha_reg_entrada: register.inDate != null ? dateLocalInputFormatter(register.inDate) : null,
                    n_reg_entrada: register.inRegisterNumber,
                    procedencia: procedence != null ? procedence.name : null,
                    nombre: third.name,
                    apellido1: third.surname1,
                    apellido2: third.surname2,
                    identificacion: third.document,
                    telefono1: third.phone1,
                    telefono2: third.phone2,
                    fec_nac: dateLocalInputFormatter(third.birthday),
                    correo: third.email,
                    tipo_via: thirdAddress.streetTypeId != null ? await this.getName(thirdAddress.streetTypeId) : null,
                    nombre_via: thirdAddress.streetId != null ? await this.getName(thirdAddress.streetId) : null,
                    numero: thirdAddress.number,
                    municipio: thirdAddress.municipalityId != null ? await this.getName(thirdAddress.municipalityId) : null,
                    zona: thirdAddress.districId != null ? await this.getName(thirdAddress.districId) : null,
                    solicita: register.request,
                    agente: agentData ? agentData.name + ' ' + agentData.surname1 + ' ' + agentData.surname2 : null,
                    informe: register.report,
                    cargo_firmante: signer ? signer.cargo : null,
                    municipio_policia: signer ? await this.getName(signer.municipality_id) : null,
                };
            }
            catch (error) {
                console.log(error);
            }
            let inOutNumber;
            if (register.inRegisterNumber != null) {
                inOutNumber = register.inRegisterNumber;
            }
            else {
                inOutNumber = register.outRegisterNumber;
            }
            await fileServices.downloadFile(REGISTERSINTOOUT, inOutNumber, data, file);
        }
        catch (error) { }
    }
    async writeCitationFile(register, file) {
        let data;
        let third = await thirdsService.findOne(register.thirdId);
        try {
            let content, procedence, thirdAddress, agentData, signer;
            if (register.origin != null) {
                procedence = await procedencesService.findOne(register.origin);
            }
            if (register.content != null) {
                content = await containsService.findOne(register.content);
            }
            try {
                thirdAddress = await directionsService.findOne(third.addressId);
            }
            catch (error) {
                console.log(error);
            }
            if (register.agentId != null) {
                agentData = (await usersService.findOneByAgentId(register.agentId)).getState();
            }
            signer = await usersService.findUserSigner();
            try {
                data = {
                    n_reg_entrada: register.inRegistNumber,
                    fecha_reg_entrada: register.inDate != null ? dateLocalInputFormatter(register.inDate) : null,
                    n_reg_salida: register.outRegistNumber != null ? register.outRegistNumber : '',
                    fecha_reg_salida: register.outDate != null ? dateLocalInputFormatter(register.outDate) : null,
                    procedencia: procedence != null ? procedence.name : '',
                    solicita: register.request,
                    agente: agentData ? agentData.name + ' ' + agentData.surname1 + ' ' + agentData.surname2 : null,
                    informe: register.report,
                    contenido: content != null ? content.name : '',
                    bloq_salida: register.outPutLock,
                    n_expediente: register.expedientNumber,
                    nombre: third.name,
                    apellido1: third.surname1,
                    apellido2: third.surname2,
                    identificacion: third.document,
                    telefono1: third.phone1,
                    telefono2: third.phone2,
                    fec_nac: dateLocalInputFormatter(third.birthday),
                    correo: third.email,
                    tipo_via: thirdAddress.streetTypeId != null ? await this.getName(thirdAddress.streetTypeId) : null,
                    nombre_via: thirdAddress.streetId != null ? await this.getName(thirdAddress.streetId) : null,
                    numero: thirdAddress.number,
                    municipio: thirdAddress.municipalityId != null ? await this.getName(thirdAddress.municipalityId) : null,
                    zona: thirdAddress.districId != null ? await this.getName(thirdAddress.districId) : null,
                    firmante: signer ? signer.name + ' ' + signer.surname1 + ' ' + signer.surname2 : null,
                    cargo_firmante: signer ? signer.cargo : null,
                    municipio_policia: signer ? await this.getName(signer.municipality_id) : null,
                };
            }
            catch (error) {
                console.log(error);
            }
            let inOutNumber;
            if (register.inRegistNumber != null) {
                inOutNumber = register.inRegistNumber;
            }
            else {
                inOutNumber = register.outRegistNumber;
            }
            await fileServices.downloadFile(REGISTERSCITATIONS, inOutNumber, data, file);
        }
        catch (error) { }
    }
    async writeAntecedentFile(register, file) {
        let data;
        try {
            let third = await thirdsService.findOne(register.thirdId);
            let antecedent, procedence, thirdAddress, agentData, signer;
            if (register.antecedentType != null) {
                antecedent = await paramsService.findOne(register.antecedentType);
            }
            if (register.origin != null) {
                procedence = await procedencesService.findOne(register.origin);
            }
            try {
                thirdAddress = await directionsService.findOne(third.addressId);
            }
            catch (error) {
                console.log(error);
            }
            if (register.agentId != null) {
                agentData = (await usersService.findOneByAgentId(register.agentId)).getState();
            }
            signer = await usersService.findUserSigner();
            data = {
                fecha: register.dateCreated != null ? dateLocalInputFormatter(register.dateCreated) : null,
                fecha_final: register.deadlineDate != null ? dateLocalInputFormatter(register.deadlineDate) : null,
                procedencia: procedence ? procedence.name : 'null',
                agente: agentData ? agentData.name + ' ' + agentData.surname1 + ' ' + agentData.surname2 : null,
                antecedente: antecedent ? antecedent.name : '',
                nombre: third.name,
                apellido1: third.surname1,
                apellido2: third.surname2,
                identificacion: third.document,
                telefono1: third.phone1,
                telefono2: third.phone2,
                fec_nac: dateLocalInputFormatter(third.birthday),
                correo: third.email,
                tipo_via: thirdAddress.streetTypeId != null ? await this.getName(thirdAddress.streetTypeId) : null,
                nombre_via: thirdAddress.streetId != null ? await this.getName(thirdAddress.streetId) : null,
                numero: thirdAddress.number,
                municipio: thirdAddress.municipalityId != null ? await this.getName(thirdAddress.municipalityId) : null,
                zona: thirdAddress.districId != null ? await this.getName(thirdAddress.districId) : null,
                firmante: signer ? signer.name + ' ' + signer.surname1 + ' ' + signer.surname2 : null,
                cargo_firmante: signer ? signer.cargo : null,
                municipio_policia: signer ? await this.getName(signer.municipality_id) : null,
            };
            await fileServices.downloadFile(REGISTERSEXTERNALANTECEDENTS, 'antecedente-' + dateInputFormatter(register.dateCreated), data, file);
        }
        catch (error) { }
    }
    async writeDetainedFile(register, file) {
        let data;
        let third = await thirdsService.findOne(register.thirdId);
        try {
            let destination, procedence, crime, thirdAddress, signer;
            if (register.origin != null) {
                procedence = await procedencesService.findOne(register.origin);
            }
            if (register.destination != null) {
                destination = await procedencesService.findOne(register.destination);
            }
            if (register.crime != null) {
                crime = await subtypesDiligencesService.findOne(register.crime);
            }
            try {
                thirdAddress = await directionsService.findOne(third.addressId);
            }
            catch (error) {
                console.log(error);
            }
            signer = await usersService.findUserSigner();
            try {
                data = {
                    n_reg_entrada: register.inRegister,
                    fecha_reg_entrada: register.inDate != null ? dateLocalInputFormatter(register.inDate) : null,
                    hora_reg_entrada: dateTimeInputFormatter(register.inDate),
                    n_reg_salida: register.outRegister,
                    fecha_reg_salida: register.outDate != null ? dateLocalInputFormatter(register.outDate) : null,
                    hora_reg_salida: dateTimeInputFormatter(register.outDate),
                    procedencia: procedence != null ? procedence.name : '',
                    destinatario: destination != null ? destination.name : '',
                    agente_receptor: register.agentReceptorId != null ? await this.getName(register.agentReceptorId) : '',
                    agente_entrega: register.agentDeliveryId != null ? await this.getName(register.agentDeliveryId) : '',
                    diligencia: register.diligenceId,
                    delito: crime != null ? crime.subTypeDiligence : null,
                    observaciones: register.observations,
                    nombre: third.name,
                    apellido1: third.surname1,
                    apellido2: third.surname2,
                    identificacion: third.document,
                    telefono1: third.phone1,
                    telefono2: third.phone2,
                    fec_nac: dateLocalInputFormatter(third.birthday),
                    correo: third.email,
                    tipo_via: thirdAddress.streetTypeId != null ? await this.getName(thirdAddress.streetTypeId) : null,
                    nombre_via: thirdAddress.streetId != null ? await this.getName(thirdAddress.streetId) : null,
                    numero: thirdAddress.number,
                    municipio: thirdAddress.municipalityId != null ? await this.getName(thirdAddress.municipalityId) : null,
                    zona: thirdAddress.districId != null ? await this.getName(thirdAddress.districId) : null,
                };
            }
            catch (error) {
                console.log(error);
            }
            let inOutNumber;
            if (register.inRegister != null) {
                inOutNumber = register.inRegister;
            }
            else {
                inOutNumber = register.outRegister;
            }
            await fileServices.downloadFile(REGISTERSDETAINED, inOutNumber, data, file);
        }
        catch (error) { }
    }
    async writeUnidentifiedFile(register, file) {
        let data;
        try {
            let motive, address, fullAddress;
            if (register.motivoidentificacion != null) {
                motive = await containsService.findOne(register.motivoidentificacion);
            }
            address = await directionsService.findOne(register.lugaridentificacion);
            try {
            }
            catch (error) {
                fullAddress =
                    await this.getName(address.streetTypeId) + ' '
                        + await this.getName(address.streetId) + ' '
                        + address.number + ','
                        + await this.getName(address.municipalityId);
            }
            data = {
                n_identificacion: register.nidentifica,
                fecha_entrada: register.fecentrada != null ? dateLocalInputFormatter(register.fecentrada) : null,
                hora_inicio: dateTimeInputFormatter(register.horainicio),
                hora_salida: dateTimeInputFormatter(register.horafin),
                motivo: motive ? motive.name : null,
                agente: register.nagente != null ? await this.getName(register.nagente) : null,
                diligencia: register.diligenciasidentificacion,
                observaciones: register.observaciones,
                direccion: fullAddress
            };
            await fileServices.downloadFile(REGISTERSUNIDENTIFIEDPERSON, register.nidentifica, data, file);
        }
        catch (error) { }
    }
    async getName(id) {
        try {
            return await paramsService.findOne(id).then(param => param.name);
        }
        catch (error) {
            console.log(error);
        }
    }
}
